@if (detail(); as d) { @if (prices().length === 0) {
<div
  class="enr-section-card enr-section-card--readonly pricing-blank"
  role="status"
>
  <div class="pricing-blank__title">No prices on this package</div>
  <div class="pricing-blank__text">
    Once the catalog publishes a productOfferingPrice for this offering it will
    appear here for editing.
  </div>
</div>
} @else {
<div class="pricing" [style.--pricing-section-air]="sectionAir">
  <div class="pricing__below">
    <!-- Side nav (scroll-spy + click-to-scroll). -->
    <nav class="pricing__sidenav" aria-label="Form sections">
      @for (g of groups(); track g.id) {
      <div class="pricing__sidenav-block flex flex-col gap-0.5">
        <button
          type="button"
          class="pricing__sidenav-group"
          [class.pricing__sidenav-group--active]="activeGroup() === g.id"
          [attr.aria-expanded]="activeGroup() === g.id"
          [attr.aria-controls]="
            activeGroup() === g.id ? 'pricing-group-list-' + g.id : null
          "
          [attr.data-testid]="'pricing-group-' + g.id"
          (click)="selectGroup(g.id)"
        >
          <mat-icon class="pricing__sidenav-group-icon" aria-hidden="true"
            >{{ g.icon }}</mat-icon
          >
          <span class="flex min-w-0 flex-1 flex-col">
            <span class="truncate">{{ g.label }}</span>
            <span class="pricing__sidenav-group-sub truncate" lang="th"
              >{{ g.subLabelTh }}</span
            >
          </span>
          @if (issueCounts()[g.id]; as count) {
          <span
            class="pricing__sidenav-count"
            [attr.aria-label]="count + (count === 1 ? ' issue' : ' issues')"
            >{{ count }}</span
          >
          }
          <mat-icon class="pricing__sidenav-chevron" aria-hidden="true"
            >expand_more</mat-icon
          >
        </button>
        @if (activeGroup() === g.id) {
        <ul class="pricing__sidenav-list" [id]="'pricing-group-list-' + g.id">
          @for (s of g.sections; track s.id; let i = $index) { @let issues =
          sectionIssueCounts().get(s.id) ?? 0;
          <li>
            <button
              type="button"
              class="pricing__sidenav-item"
              [class.pricing__sidenav-item--active]="activeSection() === s.id"
              [class.pricing__sidenav-item--issue]="issues > 0"
              (click)="selectSection(s.id)"
              [attr.aria-current]="activeSection() === s.id ? 'true' : null"
              [attr.aria-label]="
                issues > 0
                  ? s.label + ' · ' + issues + (issues === 1 ? ' issue' : ' issues')
                  : null
              "
            >
              <span class="pricing__sidenav-num"
                >{{ i + 1 }} @if (issues > 0) {
                <span
                  class="pricing__sidenav-issue-dot"
                  data-testid="pricing-section-issue"
                  aria-hidden="true"
                ></span>
                }
              </span>
              <span class="pricing__sidenav-label">{{ s.label }}</span>
            </button>
          </li>
          }
        </ul>
        }
      </div>
      }
    </nav>

    <!-- Form pane — full width minus side nav. -->
    <section class="pricing__pane" aria-label="Selected price details">
      @if (selectedPrice(); as p) {
      <div class="pricing__pane-head">
        @let w = selectedValidFor();
        <div
          class="flex flex-col gap-2"
          data-testid="pricing-selected-valid-for"
        >
          <div class="flex flex-wrap items-center gap-2">
            <span class="text-sm font-semibold">ValidFor</span>
            <span class="pricing__readonly-pill">Catalog · read-only</span>
            @if (!w) {
            <span class="enr-text-surface text-sm font-medium italic"
              >No ValidFor</span
            >
            } @else if (w.stateLabel) {
            <enr-badge
              variant="soft"
              size="small"
              data-testid="pricing-valid-for-state"
              [color]="validForBadgeColor[w.state] ?? 'neutral'"
              >{{ w.stateLabel }}</enr-badge
            >
            } @if (appLink(); as link) {
            <button
              type="button"
              class="pricing__pane-app-link ml-auto"
              data-testid="pricing-btn-copy-app-link"
              [enrTooltip]="link"
              enrTooltipPosition="bottom"
              [enrTooltipShowDelay]="0"
              aria-label="Generate the myAIS deeplink for this price"
              (click)="copyAppLink()"
            >
              <mat-icon aria-hidden="true"
                >{{ appLinkCopied() ? "check" : "link" }}</mat-icon
              >
              {{ appLinkCopied() ? "Generated" : "Generate Deeplink" }}
            </button>
            }
          </div>
          <dl
            class="m-0 grid gap-3 sm:grid-cols-2"
            [enrTooltip]="w?.fullLabel ?? ''"
            [enrTooltipDisabled]="!w"
            enrTooltipPosition="bottom"
          >
            <div
              class="flex flex-col gap-1.5 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3"
            >
              <dt
                class="enr-text-surface flex items-center gap-1.5 text-xs uppercase tracking-wide"
              >
                <mat-icon
                  class="size-4! text-base! leading-none!"
                  aria-hidden="true"
                  >event</mat-icon
                >Valid from
              </dt>
              <dd
                class="m-0 text-base font-semibold"
                data-testid="pricing-valid-for-start"
              >
                @if (!w) { — } @else if (w.start) { {{ w.start }} } @else {
                <span class="enr-text-surface font-medium italic"
                  >No start date</span
                >
                }
              </dd>
            </div>
            <div
              class="flex flex-col gap-1.5 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3"
            >
              <dt
                class="enr-text-surface flex items-center gap-1.5 text-xs uppercase tracking-wide"
              >
                <mat-icon
                  class="size-4! text-base! leading-none!"
                  aria-hidden="true"
                  >event</mat-icon
                >Valid to
              </dt>
              <dd
                class="m-0 text-base font-semibold"
                data-testid="pricing-valid-for-end"
              >
                @if (!w) { — } @else if (w.end) { {{ w.end }} } @else {
                <span class="enr-text-surface font-medium italic"
                  >No end date</span
                >
                }
              </dd>
            </div>
          </dl>
          @if (w) {
          <p class="m-0 text-xs enr-text-surface">Times in {{ w.zone }}</p>
          }
        </div>

        <!-- Catalog reference identifiers (POP code / id, offering id,
             variant id, …) — view-only sibling identifiers for this price.
             Collapsed by default so they don't push the form down; expand
             to read/copy a code. The Price code is the same code a
             price-code search matches on. -->
        @if (externalIdentifiers().length) {
        <details class="pricing__refids">
          <summary class="pricing__refids-summary">
            <mat-icon class="pricing__refids-chev" aria-hidden="true"
              >chevron_right</mat-icon
            >
            <span class="pricing__refids-summary-label">Reference codes</span>
            <span class="pricing__refids-count"
              >{{ externalIdentifiers().length }}</span
            >
          </summary>
          <dl
            class="pricing__refids-body"
            aria-label="Catalog reference identifiers"
          >
            @for (e of externalIdentifiers(); track trackExternalId($index, e))
            {
            <div
              class="pricing__refid"
              [title]="e.owner ? e.label + ' · owner: ' + e.owner : e.label"
            >
              <dt class="pricing__refid-label">{{ e.label }}</dt>
              <dd class="pricing__refid-value">{{ e.value }}</dd>
            </div>
            }
          </dl>
        </details>
        }
      </div>

      <div class="pricing__sections">
        @if (activeGroupView(); as g) {
        <div class="flex flex-col gap-0.5" data-testid="pricing-group-hint">
          <p class="m-0 text-xs text-gray-500">
            <span class="font-semibold text-gray-900">{{ g.label }}</span>
            · Step {{ activeGroupStep() }} of {{ groups().length }} · {{ g.hint
            }}
          </p>
          <p class="m-0 text-xs text-gray-500" lang="th">{{ g.hintTh }}</p>
        </div>
        }
        <!-- Net Gift completeness alert — shown ABOVE every form section
             (before Product name) when the selected price has
             isOfferingGift=true but the catalog trio (cost code price /
             VAT amount / USSD No.) is incomplete. In-form notice only, by
             BA decision — not a readiness/publish concern, since all three
             values are catalog-owned and cannot be fixed in the portal. -->
        @if (giftAlertMissing().length) {
        <div
          class="pricing__gift-alert"
          role="alert"
          [attr.data-testid]="'enrichment-pricing-gift-alert'"
        >
          <mat-icon class="pricing__gift-alert-icon" aria-hidden="true"
            >warning</mat-icon
          >
          <div class="pricing__gift-alert-body">
            <strong>Net Gift data incomplete</strong>
            <span>
              This price has Net Gift enabled but {{ giftAlertMissing().join(",
              ") }} {{ giftAlertMissing().length === 1 ? "is" : "are" }} missing
              — these values come from the catalog and must be fixed at the
              source.
            </span>
          </div>
        </div>
        }

        <div
          id="section-ranking"
          class="enr-section-card enr-section-card--readonly pricing__form-section pricing__ranking"
          [hidden]="isSectionHidden('section-ranking')"
          data-testid="pricing-section-ranking"
        >
          <enr-collapsible
            title="Ranking scores"
            [expanded]="true"
            ariaLabel="Ranking scores"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-ranking') }}
              </span>
              <span class="enr-section-card__title">Ranking scores</span>
              @if (selectedRank(); as r) {
              <span
                class="pricing__rank-pill"
                data-testid="pricing-ranking-position"
                [attr.aria-label]="'Shown ' + r.position + ' of ' + r.total + ' in price order'"
              >
                <mat-icon aria-hidden="true">leaderboard</mat-icon>
                Shown #{{ r.position }} of {{ r.total }}
              </span>
              }
            </span>

            <div class="pricing__card-body">
              <div class="pricing__ranking-grid">
                <div
                  class="pricing__ranking-field pricing__ranking-field--marketing"
                >
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'Marketing score'"
                    placeholder="e.g. 999"
                    [value]="numStr(marketingScore())"
                    (valueChange)="onMarketingScoreChange($event)"
                  ></enr-input>
                  <span class="pricing__hint"
                    >Ranks first — higher shows earlier.</span
                  >
                </div>
                <div
                  class="pricing__ranking-field pricing__ranking-field--popular"
                >
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'Popular score'"
                    placeholder="e.g. 999"
                    [value]="numStr(popularScore())"
                    (valueChange)="onPopularScoreChange($event)"
                  ></enr-input>
                  <span class="pricing__hint"
                    >Breaks ties between equal marketing scores.</span
                  >
                </div>
              </div>
              @if (selectedRankOffset() !== null) {
              <div
                class="pricing__ranking-note"
                role="note"
                data-testid="pricing-ranking-offset-note"
              >
                <mat-icon aria-hidden="true">push_pin</mat-icon>
                <span>
                  Offset #{{ selectedRankOffset() }} is set on this price and
                  takes priority — scores only order prices with the same
                  offset.
                </span>
              </div>
              } @else {
              <div class="pricing__ranking-note pricing__ranking-note--muted">
                <mat-icon aria-hidden="true">sort</mat-icon>
                <span>
                  Order: Offset → Marketing score ↓ → Popular score ↓ → Price ↑.
                  A blank score ranks after every scored price.
                </span>
              </div>
              }
            </div>
          </enr-collapsible>
        </div>

        <!-- USSD No. — read-only, authored upstream. Its own section, shown
             only when the catalog supplied one for this price. -->
        @if (selectedUssdNo()) {
        <div
          id="section-ussd"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-ussd')"
        >
          <enr-collapsible
            title="USSD No."
            [expanded]="true"
            ariaLabel="USSD No."
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-ussd') }}
              </span>
              <span class="enr-section-card__title">USSD No.</span>
              <span class="pricing__readonly-pill">Read-only</span>
            </span>

            <div class="pricing__card-body">
              <div class="pricing__ussd">
                <span class="pricing__ussd-value">{{ selectedUssdNo() }}</span>
              </div>
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- Product Name — reuses the Overview's section-card +
             collapsible chrome so Pricing reads consistently with the
             rest of the edit pack. -->
        <div
          id="section-name"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-name')"
          data-readiness-target="name"
        >
          <enr-collapsible
            title="Product name"
            [expanded]="true"
            ariaLabel="Product name"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-name') }}
              </span>
              <span class="enr-section-card__title"
                >Product name
                <span class="pricing__req" aria-hidden="true">*</span></span
              >
            </span>

            <div class="pricing__card-body">
              <pricing-locale-input
                [value]="p.name"
                [languages]="languages()"
                [flagMissing]="true"
                type="input"
                placeholder="Enter Display name"
                tip="Tip: keep it under 40 characters so the title doesn't truncate on mobile."
                (valueChange)="onNameChange($event)"
              ></pricing-locale-input>
            </div>
          </enr-collapsible>
        </div>

        <!-- 2. Product Description -->
        <div
          id="section-description"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-description')"
        >
          <enr-collapsible
            title="Product description"
            [expanded]="true"
            ariaLabel="Product description"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-description') }}
              </span>
              <span class="enr-section-card__title">Product description</span>
            </span>

            <div class="pricing__card-body">
              <pricing-locale-input
                [value]="p.description"
                [languages]="languages()"
                [flagGaps]="true"
                type="textarea"
                placeholder="Short marketing copy explaining what the customer gets"
                (valueChange)="onDescriptionChange($event)"
              ></pricing-locale-input>
            </div>
          </enr-collapsible>
        </div>

        <!-- Key Selling is IM-only and Badge is hidden under a voice
             (CIVR / IVR) scope. The side-nav entries drop out in `sections()`
             with the same gates — hiding the body alone would leave a nav row
             pointing at nothing. -->
        @if (isImEditingChannel()) {
        <!-- 2.25 Key Selling — per-language marketing bullet copy for the price.
             Line breaks are stored as a pipe on the wire; the tab shows them as
             newlines in the textarea and converts back on save. -->
        <div
          id="section-keyselling"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-keyselling')"
        >
          <enr-collapsible
            title="Key Selling"
            [expanded]="true"
            ariaLabel="Key Selling"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-keyselling') }}
              </span>
              <span class="enr-section-card__title">Key Selling</span>
            </span>

            <div class="pricing__card-body">
              <pricing-locale-input
                [value]="keySellingText()"
                [languages]="languages()"
                [flagGaps]="true"
                type="textarea"
                placeholder="One selling point per line — e.g. + Full HD 1080p"
                (valueChange)="onKeySellingChange($event)"
              ></pricing-locale-input>
            </div>
          </enr-collapsible>
        </div>
        } @if (!isVoiceEditingChannel()) {

        <!-- 2.5 Badge — single package-level promo badge
             (displayProductBadge). Pick a preset or compose one: a per-locale
             label plus shared color / icon / shape / priority. The phone
             preview's AI Chatbot card renders it live. -->
        <div
          id="section-badge"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-badge')"
        >
          <enr-collapsible
            title="Badge"
            [expanded]="!collapsed().has('section-badge')"
            (expandedChange)="setSectionExpanded('section-badge', $event)"
            [subtitle]="
              collapsed().has('section-badge') && !hasBadge()
                ? 'No badge yet. Expand to add one.'
                : ''
            "
            ariaLabel="Badge"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-badge') }}
              </span>
              <span class="enr-section-card__title">Badge</span>
              @if (badgeHasPreview()) {
              <span
                class="pricing__badge-chip"
                [class.pricing__badge-chip--rounded]="badgePreview().shape === 'rounded'"
                [class.pricing__badge-chip--square]="badgePreview().shape === 'square'"
                [style.background]="badgePreview().bg"
                [style.color]="badgePreview().fg"
              >
                @if (badgePreview().icon && badgePreview().iconPosition !==
                'suffix') { @if (badgePreview().iconIsUrl) {
                <img
                  class="pricing__badge-chip-img"
                  [class.pricing__badge-chip-img--keep]="badgePreview().iconKeepColor"
                  [src]="badgePreview().icon"
                  alt=""
                />
                } @else {
                <span>{{ badgePreview().icon }}</span>
                } } @if (badgePreview().text) {
                <span>{{ badgePreview().text }}</span>
                } @if (badgePreview().icon && badgePreview().iconPosition ===
                'suffix') { @if (badgePreview().iconIsUrl) {
                <img
                  class="pricing__badge-chip-img"
                  [class.pricing__badge-chip-img--keep]="badgePreview().iconKeepColor"
                  [src]="badgePreview().icon"
                  alt=""
                />
                } @else {
                <span>{{ badgePreview().icon }}</span>
                } }
              </span>
              }
            </span>

            <div class="pricing__card-body">
              <p class="pricing__hint">
                A small promo label shown on the package card (e.g. “Best
                Seller”). Pick a preset to start, then fine-tune. Leave
                everything blank for no badge.
              </p>

              <!-- Preset (quick-fill) — first, so you can pick a ready-made
                   badge before fine-tuning the label/style. A custom dropdown
                   so each option shows its real CDN icon (native <select>
                   can't). -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Preset</h5>
                  <span class="pricing__hint"
                    >Pick a ready-made badge — fills the label &amp;
                    style.</span
                  >
                </header>
                <div class="pricing__badge-row pricing__badge-row--preset">
                  <button
                    type="button"
                    class="pricing__badge-select"
                    [class.pricing__badge-select--open]="badgePresetOpen()"
                    cdkOverlayOrigin
                    #presetOrigin="cdkOverlayOrigin"
                    aria-label="Badge preset"
                    [attr.aria-expanded]="badgePresetOpen()"
                    (click)="toggleBadgePreset()"
                  >
                    @if (selectedPreset(); as sp) {
                    <span
                      class="pricing__preset-icon"
                      [style.background]="colorCss(sp.badgeColor)"
                    >
                      @if (presetIconUrl(sp)) {
                      <img
                        class="pricing__badge-chip-img"
                        [class.pricing__badge-chip-img--keep]="
                        presetIconKeepColor(sp)
                      "
                        [src]="presetIconUrl(sp)"
                        alt=""
                      />
                      }
                    </span>
                    <span class="pricing__preset-text"
                      >{{ sp.text.EN || sp.id }}</span
                    >
                    } @else {
                    <span
                      class="pricing__preset-text pricing__preset-text--muted"
                      >None</span
                    >
                    }
                    <svg
                      class="pricing__preset-caret"
                      viewBox="0 0 12 12"
                      aria-hidden="true"
                    >
                      <path
                        d="M2.5 4.5L6 8L9.5 4.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="presetOrigin"
                    [cdkConnectedOverlayOpen]="badgePresetOpen()"
                    [cdkConnectedOverlayPositions]="badgePresetPositions"
                    [cdkConnectedOverlayPush]="true"
                    (overlayOutsideClick)="closeBadgePreset()"
                    (detach)="closeBadgePreset()"
                  >
                    <div class="pricing__preset-panel" role="listbox">
                      <button
                        type="button"
                        class="pricing__preset-option"
                        [class.pricing__preset-option--active]="!badge().badgeKey"
                        role="option"
                        [attr.aria-selected]="!badge().badgeKey"
                        (click)="selectBadgePreset('')"
                      >
                        <span
                          class="pricing__preset-icon pricing__preset-icon--none"
                        ></span>
                        <span
                          class="pricing__preset-text pricing__preset-text--muted"
                          >None</span
                        >
                      </button>
                      @for (t of badgeTemplates; track t.id) {
                      <button
                        type="button"
                        class="pricing__preset-option"
                        [class.pricing__preset-option--active]="
                        badge().badgeKey === t.id
                      "
                        role="option"
                        [attr.aria-selected]="badge().badgeKey === t.id"
                        (click)="selectBadgePreset(t.id)"
                      >
                        <span
                          class="pricing__preset-icon"
                          [style.background]="colorCss(t.badgeColor)"
                        >
                          @if (presetIconUrl(t)) {
                          <img
                            class="pricing__badge-chip-img"
                            [class.pricing__badge-chip-img--keep]="
                            presetIconKeepColor(t)
                          "
                            [src]="presetIconUrl(t)"
                            alt=""
                          />
                          }
                        </span>
                        <span class="pricing__preset-text"
                          >{{ t.text.EN || t.id }}</span
                        >
                      </button>
                      }
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- Label (per-locale) -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">
                    Label @if (hasBadge() && badge().isActive) {
                    <span class="pricing__req" aria-hidden="true">*</span>
                    }
                  </h5>
                  <span class="pricing__hint"
                    >The badge text — translatable.</span
                  >
                </header>
                <pricing-locale-input
                  [value]="badgeLabel()"
                  [languages]="languages()"
                  [flagMissing]="hasBadge() && badge().isActive"
                  type="input"
                  placeholder="e.g. Best Seller / ขายดี"
                  tip="Keep it short — 1–2 words read best on a small card."
                  (valueChange)="onBadgeLabelChange($event)"
                ></pricing-locale-input>
              </div>

              <!-- Style — preset, color & icon, shared across languages -->
              <div class="pricing__inner-card pricing__badge-style">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Style</h5>
                  <span class="pricing__hint">
                    Color &amp; icon — shared across languages.
                  </span>
                </header>

                <!-- Color -->
                <div
                  class="pricing__badge-row pricing__badge-row--locale-input"
                >
                  <span class="pricing__badge-row-label">Color</span>
                  <div
                    class="pricing__badge-swatches"
                    role="group"
                    aria-label="Badge color"
                  >
                    @for (c of badgeColors(); track c) {
                    <button
                      type="button"
                      class="pricing__badge-swatch"
                      [class.pricing__badge-swatch--active]="badge().color === c"
                      [style.background]="colorCss(c)"
                      [attr.aria-label]="'Use ' + badgeColorLabels[c]"
                      [attr.aria-pressed]="badge().color === c"
                      [title]="badgeColorLabels[c]"
                      (click)="onBadgeColorChange(c)"
                    ></button>
                    }
                  </div>
                </div>

                @if (isAiChatbotEditingChannel()) {
                <div class="pricing__badge-row pricing__badge-custom-color">
                  <span class="pricing__badge-row-label">Custom</span>
                  <label class="pricing__badge-custom-color-control">
                    <input
                      type="color"
                      class="pricing__badge-custom-color-input"
                      aria-label="Custom badge color"
                      [value]="badgeCustomColor()"
                      (input)="onBadgeColorChange($any($event.target).value)"
                    />
                    <span class="pricing__badge-custom-color-code">
                      {{ badgeCustomColor() }}
                    </span>
                  </label>
                </div>
                }

                <!-- Icon -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Icon</span>
                  <app-enrichment-icon-picker
                    [value]="badgeIconUrl()"
                    [excludeCategories]="['custom']"
                    (iconPick)="onBadgeIconPick($event)"
                  />
                </div>

                <!-- Position (below the icon) -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Position</span>
                  <div
                    class="pricing__badge-shapes"
                    role="group"
                    aria-label="Badge icon position"
                  >
                    @for (p of badgePositions; track p) {
                    <button
                      type="button"
                      class="pricing__badge-shape"
                      [class.pricing__badge-shape--active]="(badge().iconPosition || 'prefix') === p"
                      [attr.aria-pressed]="(badge().iconPosition || 'prefix') === p"
                      (click)="onBadgeIconPositionChange(p)"
                    >
                      {{ p }}
                    </button>
                    }
                  </div>
                </div>
              </div>

              <!-- Active + clear -->
              <div class="pricing__badge-footer">
                @if (hasBadge()) {
                <button
                  type="button"
                  class="pricing__badge-active"
                  [class.pricing__badge-active--on]="badge().isActive"
                  [attr.aria-pressed]="badge().isActive"
                  (click)="onBadgeActiveToggle(!badge().isActive)"
                >
                  <mat-icon aria-hidden="true">
                    {{ badge().isActive ? 'visibility' : 'visibility_off' }}
                  </mat-icon>
                  <span>{{ badge().isActive ? 'Active' : 'Hidden' }}</span>
                </button>

                <button
                  type="button"
                  class="pricing__badge-clear"
                  (click)="clearBadge()"
                >
                  <mat-icon aria-hidden="true">delete_outline</mat-icon>
                  <span>Remove badge</span>
                </button>
                }
              </div>

              @if (hasBadge() && !badge().isActive) {
              <p class="pricing__badge-hidden-hint" role="status">
                This badge is hidden — press Active to show it in the customer
                preview.
              </p>
              }
            </div>
          </enr-collapsible>
        </div>

        }

        <!-- 2.6 Badge (Detail) — second package-level badge
             (displayProductBadgeDetail): AIS Point + Serenade tier palette.
             Same editor as the promo Badge above, its own preset/color set.
             myAIS-only: rendered (view & edit) only when editing under the
             myAIS channel (an unset channel counts as myAIS). -->
        @if (isMyAisEditingChannel()) {
        <div
          id="section-badge-detail"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-badge-detail')"
        >
          <enr-collapsible
            title="Badge (Detail)"
            [expanded]="!collapsed().has('section-badge-detail')"
            (expandedChange)="setSectionExpanded('section-badge-detail', $event)"
            [subtitle]="
              collapsed().has('section-badge-detail') && !hasBadgeDetail()
                ? 'No detail badge yet. Expand to add one.'
                : ''
            "
            ariaLabel="Badge (Detail)"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-badge-detail') }}
              </span>
              <span class="enr-section-card__title">Badge (Detail)</span>
              @if (badgeDetailHasPreview()) {
              <span
                class="pricing__badge-chip"
                [class.pricing__badge-chip--rounded]="badgeDetailPreview().shape === 'rounded'"
                [class.pricing__badge-chip--square]="badgeDetailPreview().shape === 'square'"
                [style.background]="badgeDetailPreview().bg"
                [style.color]="badgeDetailPreview().fg"
              >
                @if (badgeDetailPreview().icon &&
                badgeDetailPreview().iconPosition !== 'suffix') { @if
                (badgeDetailPreview().iconIsUrl) {
                <img
                  class="pricing__badge-chip-img"
                  [class.pricing__badge-chip-img--keep]="badgeDetailPreview().iconKeepColor"
                  [src]="badgeDetailPreview().icon"
                  alt=""
                />
                } @else {
                <span>{{ badgeDetailPreview().icon }}</span>
                } } @if (badgeDetailPreview().text) {
                <span>{{ badgeDetailPreview().text }}</span>
                } @if (badgeDetailPreview().icon &&
                badgeDetailPreview().iconPosition === 'suffix') { @if
                (badgeDetailPreview().iconIsUrl) {
                <img
                  class="pricing__badge-chip-img"
                  [class.pricing__badge-chip-img--keep]="badgeDetailPreview().iconKeepColor"
                  [src]="badgeDetailPreview().icon"
                  alt=""
                />
                } @else {
                <span>{{ badgeDetailPreview().icon }}</span>
                } }
              </span>
              }
            </span>

            <div class="pricing__card-body">
              <p class="pricing__hint">
                A second badge shown alongside the promo Badge (e.g. “Get AIS
                Point” or a Serenade tier). Pick a preset to start, then
                fine-tune. Leave everything blank for no badge.
              </p>

              <!-- Preset (quick-fill) -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Preset</h5>
                  <span class="pricing__hint"
                    >Pick a ready-made badge — fills the label &amp;
                    style.</span
                  >
                </header>
                <div class="pricing__badge-row pricing__badge-row--preset">
                  <button
                    type="button"
                    class="pricing__badge-select"
                    [class.pricing__badge-select--open]="badgeDetailPresetOpen()"
                    cdkOverlayOrigin
                    #presetDetailOrigin="cdkOverlayOrigin"
                    aria-label="Badge (Detail) preset"
                    [attr.aria-expanded]="badgeDetailPresetOpen()"
                    (click)="toggleBadgeDetailPreset()"
                  >
                    @if (selectedDetailPreset(); as sp) {
                    <span
                      class="pricing__preset-icon"
                      [style.background]="colorCss(sp.badgeColor)"
                    >
                      @if (presetIconUrl(sp)) {
                      <img
                        class="pricing__badge-chip-img"
                        [class.pricing__badge-chip-img--keep]="
                        presetIconKeepColor(sp)
                      "
                        [src]="presetIconUrl(sp)"
                        alt=""
                      />
                      }
                    </span>
                    <span class="pricing__preset-text"
                      >{{ sp.text.EN || sp.id }}</span
                    >
                    } @else {
                    <span
                      class="pricing__preset-text pricing__preset-text--muted"
                      >None</span
                    >
                    }
                    <svg
                      class="pricing__preset-caret"
                      viewBox="0 0 12 12"
                      aria-hidden="true"
                    >
                      <path
                        d="M2.5 4.5L6 8L9.5 4.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="presetDetailOrigin"
                    [cdkConnectedOverlayOpen]="badgeDetailPresetOpen()"
                    [cdkConnectedOverlayPositions]="badgePresetPositions"
                    [cdkConnectedOverlayPush]="true"
                    (overlayOutsideClick)="closeBadgeDetailPreset()"
                    (detach)="closeBadgeDetailPreset()"
                  >
                    <div class="pricing__preset-panel" role="listbox">
                      <button
                        type="button"
                        class="pricing__preset-option"
                        [class.pricing__preset-option--active]="!badgeDetail().badgeKey"
                        role="option"
                        [attr.aria-selected]="!badgeDetail().badgeKey"
                        (click)="selectBadgeDetailPreset('')"
                      >
                        <span
                          class="pricing__preset-icon pricing__preset-icon--none"
                        ></span>
                        <span
                          class="pricing__preset-text pricing__preset-text--muted"
                          >None</span
                        >
                      </button>
                      @for (t of badgeDetailTemplates; track t.id) {
                      <button
                        type="button"
                        class="pricing__preset-option"
                        [class.pricing__preset-option--active]="
                        badgeDetail().badgeKey === t.id
                      "
                        role="option"
                        [attr.aria-selected]="badgeDetail().badgeKey === t.id"
                        (click)="selectBadgeDetailPreset(t.id)"
                      >
                        <span
                          class="pricing__preset-icon"
                          [style.background]="colorCss(t.badgeColor)"
                        >
                          @if (presetIconUrl(t)) {
                          <img
                            class="pricing__badge-chip-img"
                            [class.pricing__badge-chip-img--keep]="
                            presetIconKeepColor(t)
                          "
                            [src]="presetIconUrl(t)"
                            alt=""
                          />
                          }
                        </span>
                        <span class="pricing__preset-text"
                          >{{ t.text.EN || t.id }}</span
                        >
                      </button>
                      }
                    </div>
                  </ng-template>
                </div>
              </div>

              <!-- Label (per-locale) -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">
                    Label @if (hasBadgeDetail() && badgeDetail().isActive) {
                    <span class="pricing__req" aria-hidden="true">*</span>
                    }
                  </h5>
                  <span class="pricing__hint"
                    >The badge text — translatable.</span
                  >
                </header>
                <pricing-locale-input
                  [value]="badgeDetailLabel()"
                  [languages]="languages()"
                  [flagMissing]="hasBadgeDetail() && badgeDetail().isActive"
                  type="input"
                  placeholder="e.g. Get AIS Point / รับคะแนน AIS"
                  tip="Keep it short — 1–2 words read best on a small card."
                  (valueChange)="onBadgeDetailLabelChange($event)"
                ></pricing-locale-input>
              </div>

              <!-- Style — preset, color & icon, shared across languages -->
              <div class="pricing__inner-card pricing__badge-style">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Style</h5>
                  <span class="pricing__hint">
                    Color &amp; icon — shared across languages.
                  </span>
                </header>

                <!-- Color -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Color</span>
                  <div
                    class="pricing__badge-swatches"
                    role="group"
                    aria-label="Badge (Detail) color"
                  >
                    @for (c of badgeDetailColors(); track c) {
                    <button
                      type="button"
                      class="pricing__badge-swatch"
                      [class.pricing__badge-swatch--active]="badgeDetail().color === c"
                      [style.background]="colorCss(c)"
                      [attr.aria-label]="'Use ' + badgeColorLabels[c]"
                      [attr.aria-pressed]="badgeDetail().color === c"
                      [title]="badgeColorLabels[c]"
                      (click)="onBadgeDetailColorChange(c)"
                    ></button>
                    }
                  </div>
                </div>

                <!-- Icon -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Icon</span>
                  <app-enrichment-icon-picker
                    [value]="badgeDetailIconUrl()"
                    [excludeCategories]="['custom']"
                    (iconPick)="onBadgeDetailIconPick($event)"
                  />
                </div>

                <!-- Position (below the icon) -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Position</span>
                  <div
                    class="pricing__badge-shapes"
                    role="group"
                    aria-label="Badge (Detail) icon position"
                  >
                    @for (p of badgePositions; track p) {
                    <button
                      type="button"
                      class="pricing__badge-shape"
                      [class.pricing__badge-shape--active]="(badgeDetail().iconPosition || 'prefix') === p"
                      [attr.aria-pressed]="(badgeDetail().iconPosition || 'prefix') === p"
                      (click)="onBadgeDetailIconPositionChange(p)"
                    >
                      {{ p }}
                    </button>
                    }
                  </div>
                </div>
              </div>

              <!-- Active + clear -->
              <div class="pricing__badge-footer">
                @if (hasBadgeDetail()) {
                <button
                  type="button"
                  class="pricing__badge-active"
                  [class.pricing__badge-active--on]="badgeDetail().isActive"
                  [attr.aria-pressed]="badgeDetail().isActive"
                  (click)="onBadgeDetailActiveToggle(!badgeDetail().isActive)"
                >
                  <mat-icon aria-hidden="true">
                    {{ badgeDetail().isActive ? 'visibility' : 'visibility_off'
                    }}
                  </mat-icon>
                  <span
                    >{{ badgeDetail().isActive ? 'Active' : 'Hidden' }}</span
                  >
                </button>

                <button
                  type="button"
                  class="pricing__badge-clear"
                  (click)="clearBadgeDetail()"
                >
                  <mat-icon aria-hidden="true">delete_outline</mat-icon>
                  <span>Remove badge</span>
                </button>
                }
              </div>

              @if (hasBadgeDetail() && !badgeDetail().isActive) {
              <p class="pricing__badge-hidden-hint" role="status">
                This badge is hidden — press Active to show it in the customer
                preview.
              </p>
              }
            </div>
          </enr-collapsible>
        </div>

        <div
          id="section-badge-upsell"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-badge-upsell')"
        >
          <enr-collapsible
            title="Upsell pop up"
            [expanded]="!collapsed().has('section-badge-upsell')"
            (expandedChange)="setSectionExpanded('section-badge-upsell', $event)"
            [subtitle]="
              collapsed().has('section-badge-upsell') && !hasUpsellPopup()
                ? 'No upsell pop-up yet. Expand to add one.'
                : ''
            "
            ariaLabel="Upsell pop up"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-badge-upsell') }}
              </span>
              <span class="enr-section-card__title">Upsell pop up</span>
            </span>

            <div class="pricing__card-body">
              <div class="flex flex-wrap items-center justify-end gap-2">
                @if (hasUpsellPopup()) {
                <button
                  type="button"
                  class="pricing__badge-clear"
                  data-testid="upsell-popup-clear"
                  (click)="clearUpsellPopup()"
                >
                  <mat-icon aria-hidden="true">delete_outline</mat-icon>
                  <span>Remove pop-up</span>
                </button>
                }
                <enr-button
                  variant="outline"
                  size="small"
                  type="button"
                  data-upsell-preview-toggle
                  data-testid="upsell-popup-preview-toggle"
                  [leadingIcon]="true"
                  [attr.aria-pressed]="previewSpotlight.upsellPopupOpen()"
                  (click)="toggleUpsellPopupPreview()"
                >
                  <mat-icon slot="leading-icon"
                    >{{ previewSpotlight.upsellPopupOpen() ? "visibility_off" :
                    "visibility" }}</mat-icon
                  >
                  {{ previewSpotlight.upsellPopupOpen() ? "Hide pop-up preview"
                  : "Show pop-up preview" }}
                </enr-button>
              </div>
              <!-- Period -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Period</h5>
                </header>
                <div class="pricing__daytime-grid">
                  <div class="pricing__daytime">
                    <enr-input
                      [type]="'date'"
                      [valueFormat]="'date'"
                      [size]="'large'"
                      [label]="'Start date'"
                      ariaLabel="Start date"
                      data-testid="upsell-popup-start-date"
                      [value]="upsellStartDate()"
                      (valueChange)="onUpsellStartDateChange($event)"
                    ></enr-input>
                    <enr-select
                      [size]="'large'"
                      [label]="'Start time'"
                      ariaLabel="Start time"
                      data-testid="upsell-popup-start-time"
                      placeholder="00:00"
                      searchPlaceholder="e.g. 18"
                      [searchable]="true"
                      [value]="upsellStartTime()"
                      [disabled]="upsellStartTime() === ''"
                      [options]="upsellStartClocks()"
                      (valueChange)="onUpsellStartTimeChange($event)"
                    ></enr-select>
                  </div>
                  <div class="pricing__daytime">
                    <enr-input
                      [type]="'date'"
                      [valueFormat]="'date'"
                      [size]="'large'"
                      [label]="'Expire date'"
                      ariaLabel="Expire date"
                      data-testid="upsell-popup-end-date"
                      [value]="upsellEndDate()"
                      (valueChange)="onUpsellEndDateChange($event)"
                    ></enr-input>
                    <enr-select
                      [size]="'large'"
                      [label]="'Expire time'"
                      ariaLabel="Expire time"
                      data-testid="upsell-popup-end-time"
                      placeholder="23:59"
                      searchPlaceholder="e.g. 23"
                      [searchable]="true"
                      [value]="upsellEndTime()"
                      [disabled]="upsellEndTime() === ''"
                      [options]="upsellEndClocks()"
                      (valueChange)="onUpsellEndTimeChange($event)"
                    ></enr-select>
                  </div>
                </div>
              </div>

              <p class="pricing__hint">
                Keep it under 40 characters so the title doesn’t truncate on
                mobile.
              </p>

              <!-- Content line -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Content line</h5>
                  <span class="pricing__hint"
                    >The badge text — translatable.</span
                  >
                </header>

                <div class="pricing__upsell-lang-stack">
                  @for (language of languages(); track language.locale) {
                  <section class="pricing__upsell-lang-card">
                    <header class="pricing__upsell-lang-card-head">
                      <span
                        class="pricing__upsell-locale-dot"
                        [class.pricing__upsell-locale-dot--on]="
                          (upsellNameFor(language.locale) || '').trim().length > 0
                        "
                        aria-hidden="true"
                      ></span>
                      <span class="pricing__upsell-lang-card-code">
                        {{ language.shortCode }}
                      </span>
                      <span class="pricing__upsell-lang-card-label">
                        {{ language.label }}
                      </span>
                    </header>

                    <div class="pricing__upsell-lang-card-body">
                      <div class="pricing__upsell-field">
                        <span class="pricing__upsell-field-label"> Name </span>
                        <term-rich-editor
                          [value]="upsellNameFor(language.locale)"
                          [placeholder]="
                            'Author the Upsell copy in ' +
                            language.label +
                            ' — use the toolbar to format'
                          "
                          (valueChange)="
                            onUpsellNameChange(language.locale, $event)
                          "
                        ></term-rich-editor>
                      </div>
                    </div>
                  </section>
                  }
                </div>
              </div>

              <!-- Style — preset, color & icon, shared across languages -->
              <div class="pricing__inner-card pricing__badge-style">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Badge Pop-up</h5>
                  <span class="pricing__hint">
                    Color &amp; icon — shared across languages.
                  </span>
                </header>

                <!-- Preset supplies badgeKey plus its matching style. -->
                <div class="pricing__badge-row pricing__badge-row--preset">
                  <span class="pricing__badge-row-label">Preset</span>
                  <button
                    type="button"
                    class="pricing__badge-select"
                    [class.pricing__badge-select--open]="upsellBadgePresetOpen()"
                    cdkOverlayOrigin
                    #upsellPresetOrigin="cdkOverlayOrigin"
                    aria-label="Upsell pop-up badge preset"
                    [attr.aria-expanded]="upsellBadgePresetOpen()"
                    (click)="toggleUpsellBadgePreset()"
                  >
                    @if (selectedUpsellBadgePreset(); as preset) {
                    <span
                      class="pricing__preset-icon"
                      [style.background]="colorCss(preset.badgeColor)"
                    >
                      @if (presetIconUrl(preset)) {
                      <img
                        class="pricing__badge-chip-img"
                        [class.pricing__badge-chip-img--keep]="
                          presetIconKeepColor(preset)
                        "
                        [src]="presetIconUrl(preset)"
                        alt=""
                      />
                      }
                    </span>
                    <span class="pricing__preset-text">
                      {{ preset.text.EN || preset.id }}
                    </span>
                    } @else {
                    <span
                      class="pricing__preset-text pricing__preset-text--muted"
                    >
                      None
                    </span>
                    }
                    <svg
                      class="pricing__preset-caret"
                      viewBox="0 0 12 12"
                      aria-hidden="true"
                    >
                      <path
                        d="M2.5 4.5L6 8L9.5 4.5"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>

                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="upsellPresetOrigin"
                    [cdkConnectedOverlayOpen]="upsellBadgePresetOpen()"
                    [cdkConnectedOverlayPositions]="badgePresetPositions"
                    [cdkConnectedOverlayPush]="true"
                    (overlayOutsideClick)="closeUpsellBadgePreset()"
                    (detach)="closeUpsellBadgePreset()"
                  >
                    <div class="pricing__preset-panel" role="listbox">
                      <button
                        type="button"
                        class="pricing__preset-option"
                        [class.pricing__preset-option--active]="
                          !upsellBadge().badgeKey
                        "
                        role="option"
                        [attr.aria-selected]="!upsellBadge().badgeKey"
                        (click)="selectUpsellBadgePreset('')"
                      >
                        <span
                          class="pricing__preset-icon pricing__preset-icon--none"
                        ></span>
                        <span
                          class="pricing__preset-text pricing__preset-text--muted"
                        >
                          None
                        </span>
                      </button>
                      @for (preset of upsellBadgeTemplates; track preset.id) {
                      <button
                        type="button"
                        class="pricing__preset-option"
                        [class.pricing__preset-option--active]="
                          upsellBadge().badgeKey === preset.id
                        "
                        role="option"
                        [attr.aria-selected]="
                          upsellBadge().badgeKey === preset.id
                        "
                        (click)="selectUpsellBadgePreset(preset.id)"
                      >
                        <span
                          class="pricing__preset-icon"
                          [style.background]="colorCss(preset.badgeColor)"
                        >
                          @if (presetIconUrl(preset)) {
                          <img
                            class="pricing__badge-chip-img"
                            [class.pricing__badge-chip-img--keep]="
                              presetIconKeepColor(preset)
                            "
                            [src]="presetIconUrl(preset)"
                            alt=""
                          />
                          }
                        </span>
                        <span class="pricing__preset-text">
                          {{ preset.text.EN || preset.id }}
                        </span>
                      </button>
                      }
                    </div>
                  </ng-template>
                </div>

                <!-- Color -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Color</span>
                  <div
                    class="pricing__badge-swatches"
                    role="group"
                    aria-label="Upsell pop-up badge color"
                  >
                    @for (c of upsellBadgeColors(); track c) {
                    <button
                      type="button"
                      class="pricing__badge-swatch"
                      [class.pricing__badge-swatch--active]="upsellBadge().color === c"
                      [style.background]="colorCss(c)"
                      [attr.aria-label]="'Use ' + badgeColorLabels[c]"
                      [attr.aria-pressed]="upsellBadge().color === c"
                      [title]="badgeColorLabels[c]"
                      (click)="onUpsellBadgeColorChange(c)"
                    ></button>
                    }
                  </div>
                </div>

                <!-- Icon -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Icon</span>
                  <app-enrichment-icon-picker
                    [value]="upsellBadgeIconUrl()"
                    [excludeCategories]="['custom']"
                    (iconPick)="onUpsellBadgeIconPick($event)"
                  />
                </div>

                <!-- Position (below the icon) -->
                <div class="pricing__badge-row">
                  <span class="pricing__badge-row-label">Position</span>
                  <div
                    class="pricing__badge-shapes"
                    role="group"
                    aria-label="Upsell pop-up badge icon position"
                  >
                    @for (p of badgePositions; track p) {
                    <button
                      type="button"
                      class="pricing__badge-shape"
                      [class.pricing__badge-shape--active]="(upsellBadge().iconPosition || 'prefix') === p"
                      [attr.aria-pressed]="(upsellBadge().iconPosition || 'prefix') === p"
                      (click)="onUpsellBadgeIconPositionChange(p)"
                    >
                      {{ p }}
                    </button>
                    }
                  </div>
                </div>

                <!-- Language Badge -->
                <span class="pricing__badge-row pricing__badge-row-label"
                  >Badge label</span
                >
                <pricing-locale-input
                  [value]="upsellBadge().label"
                  [languages]="languages()"
                  type="input"
                  placeholder="e.g. Get AIS Point / รับคะแนน AIS"
                  tip="Tip: keep it under 40 characters so the title doesn't truncate on mobile."
                  (valueChange)="onUpsellBadgeLabelChange($event)"
                ></pricing-locale-input>

                <div class="pricing__badge-footer">
                  <button
                    type="button"
                    class="pricing__badge-active"
                    [class.pricing__badge-active--on]="upsellBadge().isActive"
                    [attr.aria-pressed]="upsellBadge().isActive"
                    (click)="onUpsellBadgeActiveToggle(!upsellBadge().isActive)"
                  >
                    <mat-icon aria-hidden="true">
                      {{ upsellBadge().isActive ? 'visibility' :
                      'visibility_off' }}
                    </mat-icon>
                    <span
                      >{{ upsellBadge().isActive ? 'Active' : 'Hidden' }}</span
                    >
                  </button>
                </div>

                @if (!upsellBadge().isActive) {
                <p class="pricing__badge-hidden-hint" role="status">
                  This badge is hidden — press Active to show it in the customer
                  preview.
                </p>
                }
              </div>

              <!-- Package -->
              @if (selectedPackage(); as item) {
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Package</h5>
                </header>

                <article class="pricing__package-card">
                  <div class="pricing__package-card-top">
                    <strong [title]="item.name || item.id"
                      >{{ item.name || item.id }}</strong
                    >
                    <span>{{ packagePriceLabel(item) }}</span>
                  </div>
                  <div class="pricing__package-card-details">
                    <span>{{ item.priceType || "Package price" }}</span>
                    @if (item.productCode) {
                    <span>{{ item.productCode }}</span>
                    }
                  </div>
                  <div
                    class="pricing__package-card-divider"
                    aria-hidden="true"
                  ></div>
                  <div class="pricing__package-card-meta">
                    <mat-icon aria-hidden="true">sell</mat-icon>
                    <span
                      >{{ packageMeta(item) || item.descriptionShort || item.id
                      }}</span
                    >
                  </div>
                  <button
                    type="button"
                    class="pricing__package-card-delete"
                    aria-label="Remove selected package"
                    title="Remove package"
                    (click)="removeSelectedPackage()"
                  >
                    <mat-icon aria-hidden="true">delete_outline</mat-icon>
                  </button>
                </article>
              </div>
              } @else {
              <!-- Active + clear -->
              <div class="pricing__badge-footer justify-end">
                <enr-button
                  variant="primary"
                  size="medium"
                  type="button"
                  [leadingIcon]="true"
                  (click)="openPackageDrawer()"
                >
                  <mat-icon slot="leading-icon">add</mat-icon>
                  Package
                </enr-button>
              </div>
              }
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- Shelf & Category — per-price shelf/category placements. Mirrors the
             offering Shelf tab but binds THIS price into the customer-facing
             navigation (its own shelves[], independent of the offering). The
             catalog is channel-scoped via [channel]. PARKED for a later
             release — gated by `showPriceShelf` (kept wired, hidden for now). -->
        @if (showPriceShelf) {
        <div
          id="section-shelf"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-shelf')"
        >
          <enr-collapsible
            title="Shelf & Category"
            [expanded]="true"
            ariaLabel="Shelf & Category"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-shelf') }}
              </span>
              <span class="enr-section-card__title">Shelf &amp; Category</span>
            </span>

            <app-enrichment-price-shelf
              [boundShelves]="selectedPriceShelves()"
              [channel]="channel() || ''"
              (shelfAdd)="addPriceShelf($event)"
              (shelfRemove)="removePriceShelf($event)"
              (shelvesAdd)="addPriceShelves($event)"
              (shelvesRemove)="removePriceShelves($event)"
            ></app-enrichment-price-shelf>
          </enr-collapsible>
        </div>
        }

        <!-- 3. Price & currency — the authored ex-VAT / incl-VAT pair plus
             the currency label. The two amounts are the real price editors:
             saving copies incl-VAT onto the POP's displayed price and sets
             the VAT line to their difference (BFF price_amount.go). -->
        <div
          id="section-price"
          class="enr-section-card pricing__form-section"
          [hidden]="isSectionHidden('section-price')"
        >
          <enr-collapsible
            title="Price & currency"
            [expanded]="!collapsed().has('section-price')"
            (expandedChange)="setSectionExpanded('section-price', $event)"
            [subtitle]="
              collapsed().has('section-price') ? priceSubtitle() : ''
            "
            ariaLabel="Price & currency"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-price') }}
              </span>
              <span class="enr-section-card__title">Price & currency</span>
            </span>

            <div class="pricing__card-body">
              <!-- Catalog-defined price type is view-only. Keep it with the
                   selected price's amount/currency details so it is visible
                   for both prepaid and postpaid options. -->
              <div class="pricing__inner-card" data-testid="price-type-display">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Price type</h5>
                  <span class="pricing__readonly-pill">Read-only</span>
                </header>
                @if (selectedPriceType()) {
                <div class="pricing__ptype">
                  <mat-icon class="pricing__ptype-icon" aria-hidden="true"
                    >sell</mat-icon
                  >
                  <span class="pricing__ptype-label"
                    >{{ selectedPriceType() }}</span
                  >
                </div>
                } @else {
                <span class="pricing__ptype-empty">Not set</span>
                }
                <p class="pricing__hint">
                  How this option is charged, defined by the catalog.
                </p>
              </div>

              <!-- Amounts + currency stack. Vertical, not the old 2-col
                   split: the amounts row is itself three columns
                   (excl. VAT / VAT / incl. VAT) and needs the full width. -->
              <div
                class="pricing__price-grid"
                data-testid="price-currency-grid"
              >
                <!-- Net Gift POPs price on `offeringGift.costCodePrice` and
                     bypass tax[] entirely, so the amount pair is meaningless
                     there — the Cost code price card below owns pricing. -->
                @if (!selectedIsOfferingGift()) {
                <div
                  class="pricing__inner-card pricing__amounts-card"
                  data-testid="price-amounts-section"
                  aria-labelledby="price-amounts-heading"
                >
                  <header class="pricing__inner-head">
                    <h5 id="price-amounts-heading" class="pricing__inner-title">
                      Price
                    </h5>
                    @if (!mayEditPrice()) {
                    <span
                      class="pricing__readonly-pill"
                      data-testid="price-amounts-readonly"
                    >
                      Read-only
                    </span>
                    } @else if (!priceAmountUnlocked()) {
                    <!-- Has the right, has not asked to use it yet. A
                       different state from Read-only on purpose: reusing
                       that pill would tell an author they lack a right
                       they hold. -->
                    <span
                      class="pricing__locked-pill"
                      data-testid="price-amounts-locked"
                    >
                      <mat-icon aria-hidden="true">lock</mat-icon>
                      Locked
                    </span>
                    <enr-button
                      variant="text"
                      size="small"
                      data-testid="price-amounts-unlock"
                      [leadingIcon]="true"
                      (clicked)="startPriceAmountEdit()"
                    >
                      <span
                        slot="leading-icon"
                        class="flex items-center justify-center"
                      >
                        <mat-icon
                          class="size-4.5! text-[18px]! leading-4.5!"
                          aria-hidden="true"
                          >edit</mat-icon
                        >
                      </span>
                      Edit price
                    </enr-button>
                    } @else {
                    <enr-button
                      variant="text"
                      size="small"
                      data-testid="price-amounts-cancel"
                      (clicked)="cancelPriceAmountEdit()"
                    >
                      Cancel
                    </enr-button>
                    } @if (fillFromRateLabel()) {
                    <enr-button
                      variant="text"
                      size="small"
                      data-testid="price-fill-from-rate"
                      (clicked)="fillFromVatRate()"
                    >
                      {{ fillFromRateLabel() }}
                    </enr-button>
                    }
                  </header>

                  <div class="pricing__amounts-grid">
                    <label class="pricing__amount-input">
                      <span class="pricing__field-label">Price excl. VAT</span>
                      <span class="pricing__number-wrap">
                        <input
                          class="pricing__number"
                          data-testid="price-duty-free"
                          type="number"
                          min="0"
                          step="0.01"
                          [disabled]="!mayEditPriceNow()"
                          [value]="selectedDutyFreeAmount()"
                          [placeholder]="dutyFreeStoredHint() || '0.00'"
                          [attr.aria-invalid]="priceAmountError() ? true : null"
                          [attr.aria-describedby]="priceAmountError() ? 'price-amount-error' : null"
                          (input)="onDutyFreeAmountChange($any($event.target).value)"
                        />
                        @if (selectedCurrencyLabel()) {
                        <span class="pricing__number-unit">
                          {{ selectedCurrencyLabel() }}
                        </span>
                        }
                      </span>
                      @if (dutyFreeStoredHint()) {
                      <span class="pricing__field-note">
                        Leave blank to keep {{ dutyFreeStoredHint() }}.
                      </span>
                      }
                    </label>

                    <!-- Derived VAT sits between the two fields: it is the
                       difference the save writes onto tax[0], not an input. -->
                    <div
                      class="pricing__vat-strip"
                      data-testid="price-vat-derived"
                      aria-live="polite"
                    >
                      <span class="pricing__vat-label">
                        VAT @if (vatRatePercent() !== null) { {{
                        vatRatePercent() }}% }
                      </span>
                      <span class="pricing__vat-value">
                        {{ derivedVatAmount() || '—' }} @if (derivedVatAmount()
                        && selectedCurrencyLabel()) {
                        <span class="pricing__vat-unit">
                          {{ selectedCurrencyLabel() }}
                        </span>
                        }
                      </span>
                    </div>

                    <label
                      class="pricing__amount-input pricing__amount-input--primary"
                    >
                      <span class="pricing__field-label">Price incl. VAT</span>
                      <span class="pricing__number-wrap">
                        <input
                          class="pricing__number"
                          data-testid="price-tax-included"
                          type="number"
                          min="0"
                          step="0.01"
                          [disabled]="!mayEditPriceNow()"
                          [value]="selectedTaxIncludedAmount()"
                          [placeholder]="taxIncludedStoredHint() || '0.00'"
                          [attr.aria-invalid]="priceAmountError() ? true : null"
                          [attr.aria-describedby]="priceAmountError() ? 'price-amount-error' : null"
                          (input)="onTaxIncludedAmountChange($any($event.target).value)"
                        />
                        @if (selectedCurrencyLabel()) {
                        <span class="pricing__number-unit">
                          {{ selectedCurrencyLabel() }}
                        </span>
                        }
                      </span>
                      @if (taxIncludedStoredHint()) {
                      <span class="pricing__field-note">
                        Leave blank to keep {{ taxIncludedStoredHint() }}.
                      </span>
                      }
                    </label>
                  </div>

                  @if (priceAmountError()) {
                  <p
                    id="price-amount-error"
                    class="pricing__field-error"
                    data-testid="price-amount-error"
                    role="alert"
                  >
                    {{ priceAmountError() }}
                  </p>
                  } @else if (vatDriftHint()) {
                  <p class="pricing__drift-hint" data-testid="price-vat-drift">
                    {{ vatDriftHint() }}
                  </p>
                  } @if (!mayEditPrice()) {
                  <p class="pricing__hint" data-testid="price-amounts-no-perm">
                    Editing the price needs the Enrichment Publish permission.
                  </p>
                  } @else if (!priceAmountUnlocked()) {
                  <p
                    class="pricing__hint"
                    data-testid="price-amounts-locked-hint"
                  >
                    Locked so a save of anything else on this price cannot move
                    it. Choose Edit price to change it.
                  </p>
                  } @else {
                  <p class="pricing__hint">
                    Saving updates the package's displayed price and its VAT
                    line.
                  </p>
                  }
                </div>
                }

                <div class="pricing__inner-card">
                  <header class="pricing__inner-head">
                    <h5 class="pricing__inner-title">Currency</h5>
                  </header>
                  <pricing-locale-input
                    [value]="currencyEditorValue()"
                    [languages]="languages()"
                    [flagGaps]="true"
                    type="input"
                    placeholder="e.g. THB / บาท"
                    (valueChange)="onCurrencyChange($event)"
                  ></pricing-locale-input>
                </div>
              </div>

              <!-- Discount + Customer persona: authored under AI Chatbot and
                   under CIVR (the CIVR form tab used to carry both). The pill
                   names whichever scope is being edited. -->
              @if (isAiChatbotEditingChannel() || isVoiceEditingChannel()) {
              <div
                class="pricing__inner-card pricing__discount-card"
                data-testid="price-discount-section"
                aria-labelledby="price-discount-heading"
              >
                <header class="pricing__inner-head">
                  <h5 id="price-discount-heading" class="pricing__inner-title">
                    Discount price
                  </h5>
                  <span class="pricing__readonly-pill"
                    >{{ channelPillLabel() }}</span
                  >
                </header>
                <p class="pricing__hint">
                  Optional package pricing. Enter the VAT-included amount
                  manually.
                </p>

                <div
                  class="pricing__inner-grid pricing__inner-grid--2col pricing__discount-grid"
                >
                  <label class="pricing__amount-input">
                    <span class="pricing__field-label">Price discount</span>
                    <input
                      class="pricing__number"
                      data-testid="price-discount"
                      type="number"
                      min="0"
                      step="0.01"
                      [value]="selectedPriceDiscountInput()"
                      (input)="onPriceDiscountChange($any($event.target).value)"
                    />
                  </label>

                  <label class="pricing__amount-input">
                    <span class="pricing__field-label"
                      >Price discount include VAT</span
                    >
                    <input
                      class="pricing__number"
                      data-testid="price-discount-include-vat"
                      type="number"
                      min="0"
                      step="0.01"
                      [value]="selectedPriceDiscountIncludeVatInput()"
                      (input)="onPriceDiscountIncludeVatChange($any($event.target).value)"
                    />
                  </label>

                  <label class="pricing__amount-input">
                    <span class="pricing__field-label">Discount duration</span>
                    <input
                      class="pricing__number"
                      data-testid="price-discount-duration"
                      type="number"
                      min="1"
                      step="1"
                      [value]="selectedPriceDiscountDurationInput()"
                      [attr.aria-invalid]="priceDiscountDurationError() ? true : null"
                      [attr.aria-describedby]="priceDiscountDurationError() ? 'price-discount-duration-error' : null"
                      (input)="onPriceDiscountDurationChange($any($event.target).value)"
                    />
                  </label>

                  <!-- A div, not a <label>: enr-select renders its own
                       role="button" trigger, which a wrapping <label> can't
                       target. The heading stays a sibling span so this field
                       lines up with the number inputs beside it rather than
                       using enr-select's built-in `label`. -->
                  <div class="pricing__amount-input">
                    <span class="pricing__field-label">Duration unit</span>
                    <enr-select
                      [size]="'large'"
                      data-testid="price-discount-duration-unit"
                      ariaLabel="Discount duration unit"
                      placeholder="Select unit"
                      [clearable]="true"
                      [options]="priceDiscountDurationUnitOptions"
                      [value]="selectedPriceDiscountDurationUnit()"
                      (valueChange)="onPriceDiscountDurationUnitChange($any($event))"
                    ></enr-select>
                  </div>

                  <!-- Which of the two amounts above the voicebot says out
                       loud. A key of the same `priceDiscount` object, so it
                       clears with the block rather than on its own. -->
                  @if (isVoiceEditingChannel()) {
                  <div class="pricing__amount-input">
                    <span class="pricing__field-label">Price to read out</span>
                    <enr-select
                      [size]="'large'"
                      data-testid="price-play-price"
                      ariaLabel="Price to read out"
                      supportingText="Which amount the voicebot says out loud."
                      placeholder="Select price"
                      [clearable]="true"
                      [options]="playPriceOptions"
                      [value]="selectedPlayPrice()"
                      (valueChange)="onPlayPriceChange($event)"
                    ></enr-select>
                  </div>
                  }
                </div>

                @if (priceDiscountDurationError()) {
                <p
                  id="price-discount-duration-error"
                  class="pricing__field-error"
                  role="alert"
                >
                  {{ priceDiscountDurationError() }}
                </p>
                }
              </div>

              <div
                class="pricing__inner-card pricing__persona-card"
                data-testid="customer-persona-section"
                aria-labelledby="customer-persona-heading"
              >
                <header class="pricing__inner-head">
                  <h5
                    id="customer-persona-heading"
                    class="pricing__inner-title"
                  >
                    Customer persona
                  </h5>
                  <span class="pricing__readonly-pill"
                    >{{ channelPillLabel() }}</span
                  >
                </header>
                <p class="pricing__hint">
                  Optional. The persona this price is offered to.
                </p>

                <div class="pricing__amount-input">
                  <span class="pricing__field-label">Persona</span>
                  <enr-select
                    [size]="'large'"
                    data-testid="customer-persona"
                    ariaLabel="Customer persona"
                    placeholder="Select persona"
                    [clearable]="true"
                    [options]="customerPersonaOptions()"
                    [value]="selectedCustomerPersonaType()"
                    (valueChange)="onCustomerPersonaChange($any($event))"
                  ></enr-select>
                </div>
              </div>
              }

              <!-- Net Gift — cost-code price card, shown only when the POP is
                   flagged `isOfferingGift`. -->
              @if (selectedIsOfferingGift()) {
              <div class="pricing__inner-card pricing__gift-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Cost code price</h5>
                  <span class="pricing__gift-badge">Net Gift</span>
                </header>
                <div class="pricing__amount">
                  <span class="pricing__amount-value">
                    {{ costCodePriceAmount() }}
                  </span>
                  @if (selectedCurrencyLabel()) {
                  <span class="pricing__amount-currency">
                    {{ selectedCurrencyLabel() }}
                  </span>
                  }
                </div>

                <!-- VAT breakdown — BE ships `costCodePrice` (net) alongside
                     `vatAmount`; both rows hide when BE sends no VAT. -->
                @if (costCodeVatAmount()) {
                <ul class="pricing__gift-breakdown">
                  <li class="pricing__gift-row">
                    <span class="pricing__gift-row-label">VAT</span>
                    <span class="pricing__gift-row-value">
                      <strong>{{ costCodeVatAmount() }}</strong>
                      @if (selectedCurrencyLabel()) {
                      <span class="pricing__gift-row-unit">
                        {{ selectedCurrencyLabel() }}
                      </span>
                      }
                    </span>
                  </li>
                  @if (costCodePriceInclVat()) {
                  <li class="pricing__gift-row pricing__gift-row--total">
                    <span class="pricing__gift-row-label">Total incl. VAT</span>
                    <span class="pricing__gift-row-value">
                      <strong>{{ costCodePriceInclVat() }}</strong>
                      @if (selectedCurrencyLabel()) {
                      <span class="pricing__gift-row-unit">
                        {{ selectedCurrencyLabel() }}
                      </span>
                      }
                    </span>
                  </li>
                  }
                </ul>
                }

                <p class="pricing__hint">
                  Gift cost from the catalog cost code — shown because this
                  offering is a Net Gift. The cost code price excludes VAT.
                </p>
              </div>
              }
            </div>
          </enr-collapsible>
        </div>

        <!-- 4. Tax — read-only tax lines + isTaxIncluded badge -->
        <div
          id="section-tax"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-tax')"
        >
          <enr-collapsible
            title="Tax"
            [expanded]="!collapsed().has('section-tax')"
            (expandedChange)="setSectionExpanded('section-tax', $event)"
            [subtitle]="collapsed().has('section-tax') ? taxSubtitle() : ''"
            ariaLabel="Tax"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-tax') }}
              </span>
              <span class="enr-section-card__title">Tax</span>
            </span>

            <div class="pricing__card-body">
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Tax breakdown</h5>
                  @if (isTaxIncluded() === true) {
                  <span class="pricing__pill pricing__pill--ok">
                    Tax included
                  </span>
                  } @else if (isTaxIncluded() === false) {
                  <span class="pricing__pill pricing__pill--warn">
                    Tax excluded
                  </span>
                  } @else {
                  <span class="pricing__pill pricing__pill--muted">
                    Tax flag not set
                  </span>
                  }
                </header>

                @if (hasTax()) {
                <ul class="pricing__tax-list">
                  @for (t of taxRows(); track trackTaxRow($index, t)) {
                  <li class="pricing__tax-row">
                    <span class="pricing__tax-cat">{{ t.category }}</span>
                    <span class="pricing__tax-rate">{{ t.rate }}</span>
                    <span class="pricing__tax-amount">
                      <strong>{{ t.amount }}</strong>
                      @if (t.unit) {
                      <span class="pricing__tax-unit">{{ t.unit }}</span>
                      }
                    </span>
                  </li>
                  }
                </ul>
                } @else {
                <p class="pricing__empty">No tax lines on this price.</p>
                }
              </div>
            </div>
          </enr-collapsible>
        </div>

        <!-- Source of Fund — per-price isSof, myAIS only. Editable on every
             price the section is shown for; only the default differs by
             product type (see isSofRule). -->
        @if (isSofVisible()) {
        <div
          id="section-sof"
          class="enr-section-card pricing__form-section"
          [hidden]="isSectionHidden('section-sof')"
          data-testid="pricing-sof-container"
        >
          <enr-collapsible
            title="Source of Fund"
            [expanded]="true"
            ariaLabel="Source of Fund"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-sof') }}
              </span>
              <span class="enr-section-card__title">Source of Fund</span>
              <!-- Only the two states the toggle cannot express on its own.
                   A price that already holds a value gets no pill. -->
              @if (isSofStatus() === 'unset') {
              <span
                class="pricing__pill pricing__pill--warn"
                data-testid="pricing-sof-status"
              >
                Not saved yet · default shown
              </span>
              } @else if (isSofStatus() === 'pending') {
              <span
                class="pricing__pill pricing__pill--warn"
                data-testid="pricing-sof-status"
              >
                Unsaved change
              </span>
              }
            </span>

            <div class="pricing__card-body">
              <div class="flex flex-col gap-2">
                <!-- [id], not id="": a static attribute would also land on the
                     host element, the inner input would share it, and the
                     label's `for` would then point at the host and swallow
                     every click. -->
                <enr-toggle
                  [id]="'pricing-sof-input'"
                  label="Source of Fund"
                  color="success"
                  [checked]="isSofChecked()"
                  (change)="onIsSofChange($event)"
                  data-testid="pricing-sof-toggle"
                ></enr-toggle>
                @if (isSofStatus() === 'unset') {
                <p class="pricing__hint" data-testid="pricing-sof-hint">
                  This price has no Source of Fund in the data yet. "{{
                  isSofDefaultLabel() }}" is the default for this package and is
                  stored when you save this price.
                </p>
                } @else {
                <p class="pricing__hint" data-testid="pricing-sof-hint">
                  Applies to this price only.
                </p>
                }
              </div>
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- 5. Validity — amount + locale-map units -->
        <div
          id="section-validity"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-validity')"
        >
          <enr-collapsible
            title="Validity"
            [expanded]="true"
            ariaLabel="Validity"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-validity') }}
              </span>
              <span class="enr-section-card__title">Validity</span>
            </span>

            <div class="pricing__card-body">
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Usage period</h5>
                  <span class="pricing__hint">
                    How long the price stays valid for the customer.
                  </span>
                </header>
                <div class="pricing__measure">
                  <label class="pricing__amount-input">
                    <span class="pricing__field-label">Amount</span>
                    <!-- Spacer matches the locale-input cell's head row
                         (●TAG above each input) so the Amount input sits
                         on the same baseline as the first Units input. -->
                    <span
                      class="pricing__amount-spacer"
                      aria-hidden="true"
                    ></span>
                    <input
                      type="number"
                      class="pricing__number"
                      data-testid="validity-amount"
                      min="0"
                      step="1"
                      [value]="validity().amount ?? ''"
                      placeholder="e.g. 30"
                      (input)="onValidityAmountChange($any($event.target).value)"
                    />
                  </label>
                  <div class="pricing__measure-units">
                    <span class="pricing__field-label">Units</span>
                    <pricing-locale-input
                      [value]="validity().units"
                      [languages]="languages()"
                      [flagGaps]="true"
                      type="input"
                      placeholder="e.g. Day / วัน"
                      (valueChange)="onValidityUnitsChange($event)"
                    ></pricing-locale-input>
                  </div>
                </div>
              </div>
            </div>
          </enr-collapsible>
        </div>

        <!-- Availability — the SELLING WINDOW for this price. CIVR-overlay
             fields, so the section is gated to a voice (CIVR / IVR) scope; it
             sits beside Validity because the two are easy to confuse and the
             hint below is what tells them apart. -->
        @if (isVoiceEditingChannel()) {
        <div
          id="section-availability"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-availability')"
        >
          <enr-collapsible
            title="Availability"
            [expanded]="true"
            ariaLabel="Availability"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-availability') }}
              </span>
              <span class="enr-section-card__title">Availability</span>
              <span class="pricing__readonly-pill"
                >{{ channelPillLabel() }}</span
              >
            </span>

            <div class="pricing__card-body">
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Selling window</h5>
                  <span class="pricing__hint">
                    When this price can be sold. This is the selling window, not
                    how long the package lasts after purchase — that is Validity
                    above.
                  </span>
                  @if (hasSellingWindowBounds()) {
                  <!-- Say WHY the calendar refuses dates outside a range —
                       a bounded picker with no stated reason reads as broken. -->
                  <span class="pricing__hint" data-testid="civr-validfor-hint">
                    Both dates default to, and stay inside, this price's
                    ValidFor: {{ sellingWindowBoundsLabel() }}.
                  </span>
                  }
                </header>
                <!-- Day and clock are SEPARATE controls on purpose: one
                     `datetime` field looks tidier but hides a two-step wizard
                     whose clock is an unlabelled scroll wheel. See
                     `sellingWindowStartDate` for the full reasoning.

                     `valueFormat="date"` is LOAD-BEARING: left at its default
                     the picker emits `date.toISOString()` (UTC) for a pick and
                     the raw typed text for a keystroke — the first
                     re-introduces the very day-shift these fields were fixed
                     for, the second puts a display format on the wire. A real
                     Date is normalised to LOCAL text by the handler instead. -->
                <!-- ONE bound per row, not two side by side: this card lives
                     in the narrow left column next to the phone preview, and a
                     two-up split leaves the date box too small to show
                     "31/12/2099" without clipping. -->
                <div class="pricing__daytime-grid">
                  <div class="pricing__daytime">
                    <enr-input
                      [type]="'date'"
                      [valueFormat]="'date'"
                      [size]="'large'"
                      [label]="'Start date'"
                      ariaLabel="Start date"
                      data-testid="civr-effective-start-date"
                      [value]="sellingWindowStartDate()"
                      [minDate]="sellingWindowMin()"
                      [maxDate]="sellingWindowMax()"
                      (valueChange)="onEffectiveStartDateOnlyChange($event)"
                    ></enr-input>
                    <enr-select
                      [size]="'large'"
                      [label]="'Start time'"
                      ariaLabel="Start time"
                      data-testid="civr-effective-start-time"
                      placeholder="00:00"
                      searchPlaceholder="e.g. 18"
                      [searchable]="true"
                      [disabled]="sellingWindowStartTime() === ''"
                      [options]="sellingWindowStartClocks()"
                      [value]="sellingWindowStartTime()"
                      (valueChange)="onEffectiveStartTimeChange($event)"
                    ></enr-select>
                    <!-- Which of the two dates is MINE? The pickers look the
                         same whether the value was authored or inherited from
                         the ValidFor, so the origin still has to be stated.
                         What it must NOT say any more is "default": the
                         inherited value is written on save, and calling it a
                         default told the author the opposite of what happens. -->
                    <span
                      class="pricing__daytime-note"
                      data-testid="civr-effective-start-origin"
                    >
                      {{ sellingWindowStartAuthored() ? 'Set here' :
                      sellingWindowMin() ? 'From ValidFor · will be saved' :
                      'Not set' }}
                    </span>
                  </div>
                  <div class="pricing__daytime">
                    <enr-input
                      [type]="'date'"
                      [valueFormat]="'date'"
                      [size]="'large'"
                      [label]="'Expire date'"
                      ariaLabel="Expire date"
                      data-testid="civr-effective-end-date"
                      [value]="sellingWindowEndDate()"
                      [minDate]="sellingWindowMin()"
                      [maxDate]="sellingWindowMax()"
                      (valueChange)="onEffectiveEndDateOnlyChange($event)"
                    ></enr-input>
                    <enr-select
                      [size]="'large'"
                      [label]="'Expire time'"
                      ariaLabel="Expire time"
                      data-testid="civr-effective-end-time"
                      placeholder="23:59"
                      searchPlaceholder="e.g. 23"
                      [searchable]="true"
                      [disabled]="sellingWindowEndTime() === ''"
                      [options]="sellingWindowEndClocks()"
                      [value]="sellingWindowEndTime()"
                      (valueChange)="onEffectiveEndTimeChange($event)"
                    ></enr-select>
                    <span
                      class="pricing__daytime-note"
                      data-testid="civr-effective-end-origin"
                    >
                      {{ sellingWindowEndAuthored() ? 'Set here' :
                      sellingWindowMax() ? 'From ValidFor · will be saved' :
                      'Not set' }}
                    </span>
                  </div>
                </div>
                <!-- Read the window back as ONE sentence. Four date/time boxes
                     state it in pieces; the author is deciding one thing.
                     The crossed-over case is an ERROR, not a hint: nothing can
                     be sold at all, and it is the one mistake the POP-window
                     clamp above cannot catch. `role="alert"` so a screen
                     reader hears it when it appears, not only on focus. -->
                @if (sellingWindowInverted()) {
                <p
                  class="pricing__field-error"
                  role="alert"
                  data-testid="civr-selling-window-inverted"
                >
                  Expire date is before the start date — this price can't be
                  sold. Move either date.
                </p>
                } @else if (sellingWindowSummary()) {
                <p
                  class="pricing__field-note pricing__daytime-summary"
                  data-testid="civr-selling-window-summary"
                >
                  {{ sellingWindowSummary() }}
                </p>
                } @if (hasSellingWindowDay()) {
                <div class="pricing__daytime-actions">
                  <enr-button
                    variant="text"
                    size="small"
                    data-testid="civr-selling-window-full-day"
                    (clicked)="onSellingWindowFullDay()"
                  >
                    Sell whole days · 00:00 – 23:59
                  </enr-button>
                </div>
                }
              </div>
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- 6. Billing cycle — amount + locale-map units. Hidden for prepaid
             packages (no recurring billing cycle) and for one-time prices
             (nothing recurs, and Recurring period is its only card — keeping
             the section would leave an empty numbered shell + nav link);
             Validity stays for both. -->
        @if (!isPrepaid() && !isOneTimePriceType()) {
        <div
          id="section-billing"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-billing')"
        >
          <enr-collapsible
            title="Billing cycle"
            [expanded]="true"
            ariaLabel="Billing cycle"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-billing') }}
              </span>
              <span class="enr-section-card__title">Billing cycle</span>
            </span>

            <div class="pricing__card-body">
              <div
                class="pricing__inner-card"
                data-testid="billing-recurring-period"
              >
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Recurring period</h5>
                  <span class="pricing__hint">
                    Recurring period the customer is charged for.
                  </span>
                  @if (billingAmountInherited()) {
                  <span
                    class="pricing__readonly-pill"
                    title="The recurring amount is set on the parent package; edit it there. Units can still be translated here."
                    >Amount inherited</span
                  >
                  } @else {
                  <span
                    class="pricing__readonly-pill"
                    title="The recurring amount comes from the catalog and can't be edited here. Units can still be translated."
                    >Amount read-only</span
                  >
                  }
                </header>
                <div class="pricing__measure">
                  <label class="pricing__amount-input">
                    <span class="pricing__field-label">Amount</span>
                    <span
                      class="pricing__amount-spacer"
                      aria-hidden="true"
                    ></span>
                    <input
                      type="number"
                      class="pricing__number"
                      data-testid="billing-amount"
                      [value]="billingDuration().amount ?? ''"
                      readonly
                      aria-readonly="true"
                      placeholder="e.g. 1"
                    />
                  </label>
                  <div class="pricing__measure-units">
                    <span class="pricing__field-label">Units</span>
                    <pricing-locale-input
                      [value]="billingDuration().units"
                      [languages]="languages()"
                      [flagGaps]="true"
                      type="input"
                      placeholder="e.g. Month / เดือน"
                      (valueChange)="onBillingUnitsChange($event)"
                    ></pricing-locale-input>
                  </div>
                </div>
              </div>
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- Eligibility — every channel, per selected price. The scores that
             used to share this card now lead the pane (Ranking scores). -->
        <div
          id="section-eligibility"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-eligibility')"
        >
          <enr-collapsible
            title="Eligibility"
            [expanded]="true"
            ariaLabel="Eligibility"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-eligibility') }}
              </span>
              <span class="enr-section-card__title">Eligibility</span>
            </span>

            <div class="pricing__card-body">
              <!-- Customer eligibility -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Customer eligibility</h5>
                  <span class="pricing__hint">
                    Service-tenure and age ranges this price is eligible for.
                    Service years are stored as a number of days. Leave a pair
                    blank to remove that range.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'Minimum service years (days)'"
                    placeholder="Enter minimum"
                    [supportingText]="'Stored in days'"
                    [value]="numStr(serviceYears().min)"
                    [errorText]="serviceYearsErrors().min"
                    data-testid="service-years-min"
                    (valueChange)="onServiceYearsMinChange($event)"
                  ></enr-input>
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'Maximum service years (days)'"
                    placeholder="Enter maximum"
                    [supportingText]="'Stored in days'"
                    [value]="numStr(serviceYears().max)"
                    [errorText]="serviceYearsErrors().max"
                    data-testid="service-years-max"
                    (valueChange)="onServiceYearsMaxChange($event)"
                  ></enr-input>
                </div>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'Minimum customer age'"
                    placeholder="Enter minimum age"
                    [value]="numStr(customerAge().min)"
                    [errorText]="customerAgeErrors().min"
                    (valueChange)="onCustomerAgeMinChange($event)"
                  ></enr-input>
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'Maximum customer age'"
                    placeholder="Enter maximum age"
                    [value]="numStr(customerAge().max)"
                    [errorText]="customerAgeErrors().max"
                    (valueChange)="onCustomerAgeMaxChange($event)"
                  ></enr-input>
                </div>
              </div>

              <!-- ARPU range — a who-can-buy rule, same kind as the service
                   years and age windows above, so it lives in this section
                   rather than in its own. Voice-only, hence the local pill. -->
              @if (isVoiceEditingChannel()) {
              <div class="pricing__inner-card" data-testid="arpu-card">
                <header class="pricing__inner-head">
                  <!-- Title + pill grouped: `pricing__inner-head` is a
                       space-between flex row, so a third child would strand
                       the pill in the middle instead of beside the title. -->
                  <span class="flex items-baseline gap-2">
                    <h5 class="pricing__inner-title">ARPU range</h5>
                    <span class="pricing__readonly-pill"
                      >{{ channelPillLabel() }}</span
                    >
                  </span>
                  <span class="pricing__hint">
                    Who can subscribe, by average revenue. Fill in just one side
                    for an open-ended range — "500 and up" is a valid rule.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'ARPU from'"
                    placeholder="Enter minimum"
                    data-testid="arpu-from"
                    [value]="numStr(arpu().arpuFrom)"
                    (valueChange)="onArpuFromChange($event)"
                  ></enr-input>
                  <enr-input
                    [type]="'number'"
                    [numberMin]="0"
                    [numberAllowNegative]="false"
                    [size]="'large'"
                    [label]="'ARPU to'"
                    placeholder="Enter maximum"
                    data-testid="arpu-to"
                    [value]="numStr(arpu().arpuTo)"
                    [errorText]="arpuError()"
                    (valueChange)="onArpuToChange($event)"
                  ></enr-input>
                </div>
              </div>
              }
            </div>
          </enr-collapsible>
        </div>

        <!-- Classification — Price Classification (CONTEXT.md). Segment on every
             channel; Network Type on myAIS + AI Chatbot; Package Type / Product
             effective option are myAIS-only (gated inside the component). -->
        <div
          id="section-classification"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-classification')"
        >
          <enr-collapsible
            title="Classification"
            [expanded]="true"
            ariaLabel="Classification"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-classification') }}
              </span>
              <span class="enr-section-card__title">Classification</span>
            </span>

            <div class="pricing__card-body">
              <app-enrichment-price-classification
                [price]="selectedPriceClassification()"
                [offering]="offeringClassification()"
                [isMyAis]="isMyAisEditingChannel()"
                [showNetworkType]="isNetworkTypeEditingChannel()"
                [productType]="detail()?.productType"
                (fieldChange)="onPriceClassificationChange($event)"
              ></app-enrichment-price-classification>
            </div>
          </enr-collapsible>
        </div>

        <!-- Voice Channel Setting — the Voice AI / offer-logic fields migrated from
             the deleted CIVR form tab. Three inner cards rather than three
             top-level sections: each is thinner than any existing section, and
             inner cards are how this pane already sub-groups (see Price &
             currency, Eligibility & scores). -->
        @if (isVoiceEditingChannel()) {
        <div
          id="section-civr"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-civr')"
        >
          <enr-collapsible
            title="Voice Channel Setting"
            [expanded]="true"
            ariaLabel="Voice Channel Setting"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-civr') }}
              </span>
              <span class="enr-section-card__title">Voice Channel Setting</span>
              <span class="pricing__readonly-pill"
                >{{ channelPillLabel() }}</span
              >
            </span>

            <div class="pricing__card-body">
              <!-- Package status -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Package status</h5>
                  <span class="pricing__hint">
                    The status string the voicebot flow reads for this price.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [size]="'large'"
                    [label]="'Package status'"
                    placeholder="Enter package status"
                    data-testid="civr-offer-package-status"
                    [value]="civrText(p.offerPackageStatus)"
                    (valueChange)="onOfferPackageStatusChange($event)"
                  ></enr-input>
                </div>
              </div>

              <!-- Voice patterns -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Voice patterns</h5>
                  <span class="pricing__hint">
                    Which recording the voicebot plays for this price. Clear a
                    field to remove the pattern.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [size]="'large'"
                    [label]="'Play voice'"
                    placeholder="e.g. AG_IR_P20116662.wav"
                    data-testid="civr-pattern-play-voice"
                    [value]="civrText(p.patternPlayVoice)"
                    (valueChange)="onPatternPlayVoiceChange($event)"
                  ></enr-input>
                  <enr-input
                    [size]="'large'"
                    [label]="'Ensure PK'"
                    placeholder="e.g. AG_Ensure_IR_P20116662.wav"
                    data-testid="civr-pattern-ensure-pk"
                    [value]="civrText(p.patternEnsurePK)"
                    (valueChange)="onPatternEnsurePKChange($event)"
                  ></enr-input>
                  <enr-input
                    [size]="'large'"
                    [label]="'Play match'"
                    placeholder="e.g. ASIA_INSURANCE"
                    data-testid="civr-pattern-play-match"
                    [value]="civrText(p.patternPlayMatch)"
                    (valueChange)="onPatternPlayMatchChange($event)"
                  ></enr-input>
                </div>
              </div>

              <!-- Flags — three-way. "Not set" is a real option, not a
                   placeholder: it OMITS the key so the stored flag is
                   inherited, while No writes "N" permanently. -->
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Flags</h5>
                  <span class="pricing__hint">
                    Yes or No for this price. A flag nobody has answered yet
                    shows as No — that is how it already behaves — and is
                    written only once you choose.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-select
                    data-testid="civr-flag-insurance"
                    [size]="'large'"
                    [label]="'Insurance'"
                    ariaLabel="Insurance flag"
                    [options]="civrFlagOptions"
                    [value]="civrFlag(p.isInsurance)"
                    (valueChange)="onIsInsuranceChange($event)"
                  ></enr-select>
                  <enr-select
                    data-testid="civr-flag-best-sell"
                    [size]="'large'"
                    [label]="'Best seller'"
                    ariaLabel="Best seller flag"
                    [options]="civrFlagOptions"
                    [value]="civrFlag(p.isBestSell)"
                    (valueChange)="onIsBestSellChange($event)"
                  ></enr-select>
                  <enr-select
                    data-testid="civr-flag-proactive"
                    [size]="'large'"
                    [label]="'Proactive campaign'"
                    ariaLabel="Proactive campaign flag"
                    [options]="civrFlagOptions"
                    [value]="civrFlag(p.isProactive)"
                    (valueChange)="onIsProactiveChange($event)"
                  ></enr-select>
                </div>
              </div>
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- The same per-price characteristics the Online Store package editor
             writes (tariff-plan form config), editable here by price. -->
        @if (isOnlineStoreEditingChannel()) {
        <div
          id="section-online-store"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-online-store')"
        >
          <enr-collapsible
            title="Online Store"
            [expanded]="true"
            ariaLabel="Online Store"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-online-store') }}
              </span>
              <span class="enr-section-card__title">Online Store</span>
              <span class="pricing__readonly-pill">Online Store</span>
            </span>

            <div class="pricing__card-body">
              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">Contract</h5>
                  <span class="pricing__hint">
                    Contract term shown on the Online Store product page, e.g.
                    12 Bill Cycle.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [size]="'large'"
                    [label]="'Tariff Contract'"
                    placeholder="12 Bill Cycle"
                    data-testid="online-store-tariff-contract"
                    [value]="priceText('tariffContract')"
                    (valueChange)="setPriceText('tariffContract', civrAsText($event))"
                  ></enr-input>
                </div>
              </div>

              <div class="pricing__inner-card">
                <header class="pricing__inner-head">
                  <h5 class="pricing__inner-title">URL path</h5>
                  <span class="pricing__hint">
                    Path segments of the product page URL. Clear a field to
                    remove it.
                  </span>
                </header>
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <enr-input
                    [size]="'large'"
                    [label]="'URL Subdirectory 1'"
                    placeholder="postpaid"
                    [supportingText]="'a-z 0-9 / _ -'"
                    data-testid="online-store-url-subdirectory-1"
                    [value]="priceText('UrlSubdirectory-1')"
                    (valueChange)="setPriceText('UrlSubdirectory-1', civrAsText($event))"
                  ></enr-input>
                  <enr-input
                    [size]="'large'"
                    [label]="'URL Subdirectory 2'"
                    placeholder="postpaid-plans/5g-fixxy-799"
                    [supportingText]="'a-z 0-9 / _ -'"
                    data-testid="online-store-url-subdirectory-2"
                    [value]="priceText('UrlSubdirectory-2')"
                    (valueChange)="setPriceText('UrlSubdirectory-2', civrAsText($event))"
                  ></enr-input>
                </div>
              </div>
            </div>
          </enr-collapsible>
        </div>
        }

        <!-- 7. Service enrichment — pinned + sortable + add (each display
             is already its own collapsible card inside) -->
        <div
          id="section-services"
          class="enr-section-card enr-section-card--readonly pricing__form-section pricing__svc"
          [hidden]="isSectionHidden('section-services')"
        >
          <enr-collapsible
            title="Service enrichment"
            [expanded]="true"
            ariaLabel="Service enrichment"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-services') }}
              </span>
              <span class="enr-section-card__title">Service enrichment</span>
              <span class="pricing__svc-count"> {{ serviceCardCount() }} </span>
            </span>

            <div class="pricing__card-body">
              <!-- Broadband Speed — the BE splits speed into two displays
                   (displayBroadbandServiceDownload / ...Upload, kind
                   "broadbandspeed"). They are edited together here: Name,
                   read-only Amount and Icon are per direction (each writes to
                   its own display); Unit / Description / Notes are shared and
                   mirrored to both. -->
              @if (broadbandSpeedPair()) {
              <article class="pricing__svc-card">
                <enr-collapsible
                  title="Broadband Speed"
                  [expanded]="true"
                  ariaLabel="Broadband Speed"
                >
                  <span slot="title" class="pricing__svc-title-slot">
                    <span class="pricing__svc-title-text">Broadband Speed</span>
                    <code class="pricing__svc-id" title="broadbandspeed"
                      >download + upload</code
                    >
                  </span>

                  <div class="pricing__svc-body">
                    <p class="pricing__hint">
                      Download &amp; Upload are edited together. Name, amount
                      and icon are per direction; Unit, Description and Notes
                      apply to both.
                    </p>

                    @if (broadbandDownload(); as dl) {
                    <div
                      class="pricing__inner-card pricing__bb-dir pricing__bb-dir--download"
                      data-testid="pricing-bb-download"
                    >
                      <header class="pricing__inner-head">
                        <h5 class="pricing__inner-title">
                          <span
                            class="pricing__bb-dir-badge"
                            aria-hidden="true"
                            title="Download"
                          >
                            <mat-icon>arrow_downward</mat-icon>
                          </span>
                          Download
                          <span class="pricing__req" aria-hidden="true">*</span>
                        </h5>
                        <span class="pricing__hint">
                          Name, read-only amount and icon — this direction only
                        </span>
                      </header>
                      <pricing-locale-input
                        [value]="innerName(dl)"
                        [languages]="languages()"
                        [flagMissing]="true"
                        type="input"
                        placeholder="e.g. Download / ดาวน์โหลด"
                        (valueChange)="onInnerNameChange(dl.__index, $event)"
                      ></pricing-locale-input>
                      <ng-container
                        [ngTemplateOutlet]="quantityEditor"
                        [ngTemplateOutletContext]="{ $implicit: dl, placeholder: 'From catalog' }"
                      ></ng-container>
                      <div class="pricing__bb-icon">
                        <span class="pricing__field-label">
                          Download icon
                        </span>
                        <span class="pricing__hint">
                          Shown beside the Download speed in the preview's Speed
                          panel. Leave empty to use the default download icon.
                        </span>
                        <app-attachment-uploader
                          attachmentType="icon"
                          [single]="true"
                          container="contents"
                          [allowIconPick]="true"
                          iconSource="icon"
                          [prefix]="displayAttachmentPrefix('icon')"
                          [items]="innerAttachments(dl)"
                          (itemsChange)="onDisplayAttachmentsChange(dl.__index, $event)"
                        ></app-attachment-uploader>
                      </div>
                    </div>
                    } @if (broadbandUpload(); as ul) {
                    <div
                      class="pricing__inner-card pricing__bb-dir pricing__bb-dir--upload"
                      data-testid="pricing-bb-upload"
                    >
                      <header class="pricing__inner-head">
                        <h5 class="pricing__inner-title">
                          <span
                            class="pricing__bb-dir-badge"
                            aria-hidden="true"
                            title="Upload"
                          >
                            <mat-icon>arrow_upward</mat-icon>
                          </span>
                          Upload
                          <span class="pricing__req" aria-hidden="true">*</span>
                        </h5>
                        <span class="pricing__hint">
                          Name, read-only amount and icon — this direction only
                        </span>
                      </header>
                      <pricing-locale-input
                        [value]="innerName(ul)"
                        [languages]="languages()"
                        [flagMissing]="true"
                        type="input"
                        placeholder="e.g. Upload / อัปโหลด"
                        (valueChange)="onInnerNameChange(ul.__index, $event)"
                      ></pricing-locale-input>
                      <ng-container
                        [ngTemplateOutlet]="quantityEditor"
                        [ngTemplateOutletContext]="{ $implicit: ul, placeholder: 'From catalog' }"
                      ></ng-container>
                      <div class="pricing__bb-icon">
                        <span class="pricing__field-label">Upload icon</span>
                        <span class="pricing__hint">
                          Shown beside the Upload speed in the preview's Speed
                          panel. Leave empty to use the default upload icon.
                        </span>
                        <app-attachment-uploader
                          attachmentType="icon"
                          [single]="true"
                          container="contents"
                          [allowIconPick]="true"
                          iconSource="icon"
                          [prefix]="displayAttachmentPrefix('icon')"
                          [items]="innerAttachments(ul)"
                          (itemsChange)="onDisplayAttachmentsChange(ul.__index, $event)"
                        ></app-attachment-uploader>
                      </div>
                    </div>
                    } @if (broadbandSeed(); as seed) {
                    <div class="pricing__inner-card">
                      <header class="pricing__inner-head">
                        <h5 class="pricing__inner-title">Unit</h5>
                        <span class="pricing__hint">
                          Shared · applies to both (e.g. Mbps)
                        </span>
                      </header>
                      <pricing-locale-input
                        [value]="innerUnit(seed)"
                        [languages]="languages()"
                        type="input"
                        placeholder="e.g. Mbps"
                        (valueChange)="onBroadbandUnitChange($event)"
                      ></pricing-locale-input>
                    </div>

                    <div class="pricing__inner-card">
                      <header class="pricing__inner-head">
                        <h5 class="pricing__inner-title">Description</h5>
                        <span class="pricing__hint">
                          Shared · applies to both
                        </span>
                      </header>
                      <pricing-locale-input
                        [value]="innerDesc(seed)"
                        [languages]="languages()"
                        type="textarea"
                        placeholder="Short description"
                        (valueChange)="onBroadbandDescriptionChange($event)"
                      ></pricing-locale-input>
                    </div>

                    <div class="pricing__inner-card">
                      <header class="pricing__inner-head">
                        <h5 class="pricing__inner-title">Note</h5>
                        <span class="pricing__hint">
                          Shared · applies to both · multiple
                        </span>
                      </header>
                      <div class="pricing__note-list">
                        @for (note of innerNotes(seed); track $index; let ni =
                        $index) {
                        <div class="pricing__note-item">
                          <div class="pricing__note-controls">
                            <button
                              type="button"
                              class="pricing__svc-reorder"
                              aria-label="Move note up"
                              title="Move note up"
                              [disabled]="ni === 0"
                              (click)="moveBroadbandNoteUp(ni)"
                            >
                              <mat-icon aria-hidden="true"
                                >arrow_upward</mat-icon
                              >
                            </button>
                            <button
                              type="button"
                              class="pricing__svc-reorder"
                              aria-label="Move note down"
                              title="Move note down"
                              [disabled]="ni === innerNotes(seed).length - 1"
                              (click)="moveBroadbandNoteDown(ni)"
                            >
                              <mat-icon aria-hidden="true"
                                >arrow_downward</mat-icon
                              >
                            </button>
                            <button
                              type="button"
                              class="pricing__svc-remove"
                              aria-label="Remove note"
                              title="Remove note"
                              (click)="removeBroadbandNote(ni)"
                            >
                              <mat-icon aria-hidden="true">close</mat-icon>
                            </button>
                          </div>
                          <pricing-locale-input
                            class="pricing__note-input"
                            [value]="note"
                            [languages]="languages()"
                            type="textarea"
                            placeholder="Optional fine-print / asterisk note"
                            (valueChange)="onBroadbandNoteChange(ni, $event)"
                          ></pricing-locale-input>
                        </div>
                        } @empty {
                        <p class="pricing__hint">No notes yet.</p>
                        }
                      </div>
                      <button
                        type="button"
                        class="pricing__svc-add pricing__note-add"
                        (click)="addBroadbandNote()"
                      >
                        <mat-icon aria-hidden="true">add</mat-icon>
                        <span>Add note</span>
                      </button>
                    </div>

                    }
                  </div>
                </enr-collapsible>
              </article>
              }

              <!-- Display / Non Display split (isRemoved). Items never leave
                   `displays[]` — the buttons only flip the flag, so a restored
                   service reappears at its original position. -->
              <header
                class="pricing__svc-group-head"
                data-testid="pricing-svc-display-section"
              >
                <h4 class="pricing__svc-group-title">Display</h4>
                <span class="pricing__svc-count">
                  {{ sortableDisplays().length }}
                </span>
              </header>
              @if (sortableDisplays().length) {
              <p class="pricing__svc-intro">Drag the items to reorder them.</p>
              } @else {
              <p class="pricing__hint" data-testid="pricing-svc-display-empty">
                No services shown on this price.
              </p>
              } @if (sortableDisplays().length) {
              <div
                class="pricing__svc-sortable"
                cdkDropList
                (cdkDropListDropped)="onSortableDrop($event)"
              >
                @for (d of sortableDisplays(); track trackDisplay($index, d)) {
                <article
                  class="pricing__svc-card"
                  cdkDrag
                  [cdkDragData]="d"
                  [attr.data-readiness-target]="
                    'displays.' + d.name + '.value.name'
                  "
                >
                  <enr-collapsible
                    [title]="displayTitle(d)"
                    [expanded]="expandedDisplay() === d.name"
                    [ariaLabel]="displayTitle(d)"
                  >
                    <span slot="title" class="pricing__svc-title-slot">
                      <span class="pricing__svc-controls">
                        <button
                          type="button"
                          class="pricing__svc-handle"
                          cdkDragHandle
                          aria-label="Drag to reorder"
                          title="Drag to reorder"
                          (click)="$event.stopPropagation()"
                        >
                          <mat-icon aria-hidden="true">drag_indicator</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="pricing__svc-reorder"
                          aria-label="Move up"
                          title="Move up"
                          [disabled]="isFirstSortable(d.__index)"
                          (click)="$event.stopPropagation(); moveDisplayUp(d.__index)"
                        >
                          <mat-icon aria-hidden="true">arrow_upward</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="pricing__svc-reorder"
                          aria-label="Move down"
                          title="Move down"
                          [disabled]="isLastSortable(d.__index)"
                          (click)="$event.stopPropagation(); moveDisplayDown(d.__index)"
                        >
                          <mat-icon aria-hidden="true">arrow_downward</mat-icon>
                        </button>
                      </span>
                      <span class="pricing__svc-title-text"
                        >{{ displayTitle(d) }}</span
                      >
                      <ng-container
                        [ngTemplateOutlet]="svcKindPill"
                        [ngTemplateOutletContext]="{ $implicit: d }"
                      ></ng-container>
                      <code class="pricing__svc-id" [title]="d.name"
                        >{{ d.name }}</code
                      >
                      <button
                        type="button"
                        class="pricing__svc-remove pricing__svc-hide"
                        aria-label="Move to Non Display"
                        title="Move to Non Display (data is kept)"
                        [attr.data-testid]="'pricing-svc-hide-' + d.name"
                        (click)="$event.stopPropagation(); setDisplayRemoved(d.__index, true)"
                      >
                        <mat-icon aria-hidden="true">visibility_off</mat-icon>
                      </button>
                      @if (isOtherDisplay(d)) {
                      <button
                        type="button"
                        class="pricing__svc-remove"
                        aria-label="Delete this service"
                        title="Delete this service"
                        [attr.data-testid]="'pricing-svc-delete-' + d.name"
                        (click)="$event.stopPropagation(); removeDisplay(d.__index)"
                      >
                        <mat-icon aria-hidden="true">delete</mat-icon>
                      </button>
                      }
                    </span>

                    <div class="pricing__svc-body">
                      <!-- Kind — editable on user-created displayOther
                           services only (catalog services carry a fixed
                           kind). BA-fixed list; switching to `internet`
                           unlocks the Supporting text field below, and the
                           preview icon/benefit mapping follows the kind. -->
                      @if (isOtherDisplay(d)) {
                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Kind</h5>
                          <span class="pricing__hint">
                            Service type — drives the preview icon
                          </span>
                        </header>
                        <div class="pricing__amount-input">
                          <enr-select
                            [size]="'large'"
                            [attr.data-testid]="'pricing-svc-kind-' + d.name"
                            ariaLabel="Service kind"
                            placeholder="Select kind"
                            [options]="displayKindOptions"
                            [value]="displayKind(d)"
                            (valueChange)="setDisplayKind(d.__index, $any($event))"
                          ></enr-select>
                        </div>
                      </div>
                      }

                      <!-- Each field wraps in its own inner-card so the
                       service-item form reads as a stack of titled
                       boxes (Name / Description / Note / Quantity /
                       Attachment) instead of a flat list. -->
                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">
                            Name
                            <span class="pricing__req" aria-hidden="true"
                              >*</span
                            >
                          </h5>
                        </header>
                        <pricing-locale-input
                          [value]="innerName(d)"
                          [languages]="languages()"
                          [flagMissing]="true"
                          type="input"
                          placeholder="Service display name"
                          (valueChange)="onInnerNameChange(d.__index, $event)"
                        ></pricing-locale-input>
                      </div>

                      <!-- Supporting text (คำโปรย) — short tagline under the
                           name, per locale. Stored at value.supportingText;
                           optional, so no missing-locale flagging. Authored
                           on every display kind (the BA lifted the original
                           internet-only rule). -->
                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Supporting text</h5>
                          <span class="pricing__hint">
                            Optional · short tagline under the name
                          </span>
                        </header>
                        <pricing-locale-input
                          [value]="innerSupportingText(d)"
                          [languages]="languages()"
                          type="input"
                          placeholder="e.g. Internet 3 GB / day"
                          (valueChange)="onInnerSupportingTextChange(d.__index, $event)"
                        ></pricing-locale-input>
                      </div>

                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Description</h5>
                        </header>
                        <pricing-locale-input
                          [value]="innerDesc(d)"
                          [languages]="languages()"
                          [flagGaps]="true"
                          type="textarea"
                          placeholder="Short description"
                          (valueChange)="onInnerDescriptionChange(d.__index, $event)"
                        ></pricing-locale-input>
                      </div>

                      <!-- Speed wording — broadband (Fibre) displays only.
                           Overrides the preview Speed panel's Download / Upload
                           labels; blank falls back to the built-in default
                           (Download / Upload). The panel heading reuses the
                           Name field above. -->
                      @if (isBroadbandDisplay(d)) {
                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Speed labels</h5>
                          <span class="pricing__hint">
                            Download / Upload wording · blank = default
                          </span>
                        </header>
                        <div class="pricing__measure-units">
                          <span class="pricing__field-label"
                            >Download label</span
                          >
                          <pricing-locale-input
                            [value]="innerDownloadLabel(d)"
                            [languages]="languages()"
                            type="input"
                            placeholder="e.g. Download / ดาวน์โหลด"
                            (valueChange)="onDownloadLabelChange(d.__index, $event)"
                          ></pricing-locale-input>
                        </div>
                        <div class="pricing__measure-units">
                          <span class="pricing__field-label">Upload label</span>
                          <pricing-locale-input
                            [value]="innerUploadLabel(d)"
                            [languages]="languages()"
                            type="input"
                            placeholder="e.g. Upload / อัปโหลด"
                            (valueChange)="onUploadLabelChange(d.__index, $event)"
                          ></pricing-locale-input>
                        </div>
                      </div>
                      }

                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Note</h5>
                          <span class="pricing__hint">Optional · multiple</span>
                        </header>

                        <div class="pricing__note-list">
                          @for (note of innerNotes(d); track $index; let ni =
                          $index) {
                          <div class="pricing__note-item">
                            <div class="pricing__note-controls">
                              <button
                                type="button"
                                class="pricing__svc-reorder"
                                aria-label="Move note up"
                                title="Move note up"
                                [disabled]="ni === 0"
                                (click)="moveNoteUp(d.__index, ni)"
                              >
                                <mat-icon aria-hidden="true"
                                  >arrow_upward</mat-icon
                                >
                              </button>
                              <button
                                type="button"
                                class="pricing__svc-reorder"
                                aria-label="Move note down"
                                title="Move note down"
                                [disabled]="ni === innerNotes(d).length - 1"
                                (click)="moveNoteDown(d.__index, ni)"
                              >
                                <mat-icon aria-hidden="true"
                                  >arrow_downward</mat-icon
                                >
                              </button>
                              <button
                                type="button"
                                class="pricing__svc-remove"
                                aria-label="Remove note"
                                title="Remove note"
                                (click)="removeNote(d.__index, ni)"
                              >
                                <mat-icon aria-hidden="true">close</mat-icon>
                              </button>
                            </div>
                            <pricing-locale-input
                              class="pricing__note-input"
                              [value]="note"
                              [languages]="languages()"
                              type="textarea"
                              placeholder="Optional fine-print / asterisk note"
                              (valueChange)="onNoteChange(d.__index, ni, $event)"
                            ></pricing-locale-input>
                          </div>
                          } @empty {
                          <p class="pricing__hint">No notes yet.</p>
                          }
                        </div>

                        <button
                          type="button"
                          class="pricing__svc-add pricing__note-add"
                          (click)="addNote(d.__index)"
                        >
                          <mat-icon aria-hidden="true">add</mat-icon>
                          <span>Add note</span>
                        </button>
                      </div>

                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Quantity</h5>
                          <span class="pricing__hint">
                            Amount + display unit (e.g. 20 GB).
                          </span>
                        </header>
                        <div class="pricing__measure">
                          <ng-container
                            [ngTemplateOutlet]="quantityEditor"
                            [ngTemplateOutletContext]="{ $implicit: d, placeholder: 'Unlimited' }"
                          ></ng-container>
                          <div class="pricing__measure-units">
                            <span class="pricing__field-label">Unit</span>
                            <pricing-locale-input
                              [value]="innerUnit(d)"
                              [languages]="languages()"
                              type="input"
                              placeholder="e.g. GB / นาที / Unlimited"
                              (valueChange)="onInnerUnitChange(d.__index, $event)"
                            ></pricing-locale-input>
                          </div>
                        </div>
                      </div>

                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">Icon</h5>
                          <span class="pricing__hint">
                            Small service icon bound to this display.
                          </span>
                        </header>
                        <app-attachment-uploader
                          attachmentType="icon"
                          [single]="true"
                          container="contents"
                          [allowIconPick]="true"
                          iconSource="icon"
                          [prefix]="displayAttachmentPrefix('icon')"
                          [items]="innerAttachments(d)"
                          (itemsChange)="onDisplayAttachmentsChange(d.__index, $event)"
                        ></app-attachment-uploader>
                      </div>

                      <div class="pricing__inner-card">
                        <header class="pricing__inner-head">
                          <h5 class="pricing__inner-title">
                            Entertainment logos
                          </h5>
                          <span class="pricing__hint">
                            Partner logos (Netflix, Disney+, ...) shown with
                            this display.
                          </span>
                        </header>
                        <app-attachment-uploader
                          attachmentType="partner_logo"
                          container="contents"
                          [allowIconPick]="true"
                          iconSource="logo"
                          [prefix]="displayAttachmentPrefix('logo')"
                          [items]="innerAttachments(d)"
                          (itemsChange)="onDisplayAttachmentsChange(d.__index, $event)"
                        ></app-attachment-uploader>
                      </div>
                    </div>
                  </enr-collapsible>
                </article>
                }
              </div>
              }

              <button
                type="button"
                class="pricing__svc-add"
                (click)="addDisplayOther()"
              >
                <mat-icon aria-hidden="true">add</mat-icon>
                <span>Add service enrichment</span>
                <span class="pricing__svc-add-hint">(displayOther)</span>
              </button>

              <!-- Non Display: services kept on the record but hidden from
                   customers (isRemoved). Read-only rows — restore to Display
                   to edit; only user-created displayOther items can be
                   deleted for real. -->
              <header
                class="pricing__svc-group-head pricing__svc-group-head--muted"
                data-testid="pricing-svc-nondisplay-section"
              >
                <h4 class="pricing__svc-group-title">Non Display</h4>
                <span class="pricing__svc-count">
                  {{ removedDisplays().length }}
                </span>
              </header>
              @if (removedDisplays().length) {
              <ul class="pricing__svc-hidden-list">
                @for (d of removedDisplays(); track d.name) {
                <li
                  class="pricing__svc-hidden-row"
                  [attr.data-testid]="'pricing-svc-hidden-' + d.name"
                >
                  <mat-icon class="pricing__svc-hidden-eye" aria-hidden="true"
                    >visibility_off</mat-icon
                  >
                  <span class="pricing__svc-title-text">
                    {{ displayTitle(d) }}
                  </span>
                  <ng-container
                    [ngTemplateOutlet]="svcKindPill"
                    [ngTemplateOutletContext]="{ $implicit: d }"
                  ></ng-container>
                  <code class="pricing__svc-id" [title]="d.name">
                    {{ d.name }}
                  </code>
                  <button
                    type="button"
                    class="pricing__svc-restore"
                    aria-label="Move to Display"
                    title="Move back to Display"
                    [attr.data-testid]="'pricing-svc-restore-' + d.name"
                    (click)="setDisplayRemoved(d.__index, false)"
                  >
                    <mat-icon aria-hidden="true">visibility</mat-icon>
                    <span>Move to Display</span>
                  </button>
                  @if (isOtherDisplay(d)) {
                  <button
                    type="button"
                    class="pricing__svc-remove"
                    aria-label="Delete this service"
                    title="Delete this service permanently"
                    [attr.data-testid]="'pricing-svc-delete-' + d.name"
                    (click)="removeDisplay(d.__index)"
                  >
                    <mat-icon aria-hidden="true">delete</mat-icon>
                  </button>
                  }
                </li>
                }
              </ul>
              } @else {
              <p
                class="pricing__hint"
                data-testid="pricing-svc-nondisplay-empty"
              >
                No hidden services.
              </p>
              }
            </div>
          </enr-collapsible>
        </div>

        <!-- Agreement — Price Agreement (CONTEXT.md), on every channel. -->
        <div
          id="section-agreement"
          class="enr-section-card enr-section-card--readonly pricing__form-section"
          [hidden]="isSectionHidden('section-agreement')"
        >
          <enr-collapsible
            title="Terms &amp; Conditions"
            [expanded]="true"
            ariaLabel="Terms and Conditions"
          >
            <span slot="title" class="flex items-center gap-2">
              <span class="pricing__title-num" aria-hidden="true">
                {{ sectionNumber('section-agreement') }}
              </span>
              <span class="enr-section-card__title"
                >Terms &amp; Conditions</span
              >
            </span>

            <div class="pricing__card-body">
              <app-enrichment-price-agreement
                [agreements]="p.agreements"
                [priceName]="selectedPriceName()"
                [offeringAgreement]="offeringAgreement()"
                [usedBy]="agreementUsage()"
                (agreementChange)="onPriceAgreementChange($event)"
              ></app-enrichment-price-agreement>
            </div>
          </enr-collapsible>
        </div>

        <div
          class="flex items-center gap-3 pt-2"
          data-testid="pricing-group-footer"
        >
          @if (adjacentGroups().prev; as prev) {
          <enr-button
            variant="outline"
            size="medium"
            data-testid="pricing-group-back"
            (clicked)="selectGroup(prev.id)"
          >
            Back: {{ prev.label }}
          </enr-button>
          } @if (adjacentGroups().next; as next) {
          <enr-button
            variant="primary"
            size="medium"
            class="ml-auto"
            data-testid="pricing-group-next"
            (clicked)="selectGroup(next.id)"
          >
            Continue to {{ next.label }}
          </enr-button>
          }
        </div>
      </div>
      }
    </section>
  </div>
</div>
} } @else {
<div
  class="enr-section-card enr-section-card--readonly pricing-blank"
  role="status"
>
  <div class="pricing-blank__title">No package loaded</div>
  <div class="pricing-blank__text">
    The pricing editor will appear once the package finishes loading.
  </div>
</div>
}

<!-- ── Service quantity editor ───────────────────────────────────────────
     One definition for all three amounts (the generic service display and
     the two broadband directions) so the gate, the lock and the catalog
     hint can never drift apart between them.

     The figure is BE-derived by default: `lockBundleDisplayAmounts` rebuilds
     it from the parent catalog on every price save unless this display was
     authored, which is what the lock records. Locked therefore means "showing
     the catalog's figure", and the way back is an action, not a blank field —
     an emptied box means Unlimited here, so it cannot also mean "inherit".  -->
<ng-template #quantityEditor let-d let-placeholder="placeholder">
  <!-- ONE element, deliberately: every outlet below sits inside a grid
       (`.pricing__measure`) or a stacked card, and `ng-container` renders no
       box of its own — loose children would become grid items and land in the
       Units column. -->
  <div class="pricing__quantity">
    <div class="pricing__quantity-head">
      <span class="pricing__field-label">Amount</span>

      @if (!mayEditServiceQuantity()) {
      <span
        class="pricing__readonly-pill"
        [attr.data-testid]="'display-quantity-readonly-' + d.__index"
      >
        Read-only
      </span>
      } @else if (!quantityUnlocked(d)) {
      <!-- Locked says WHICH figure is on screen, and the two are not the same
           fact: a display still tracking the catalog, or one carrying a number
           somebody chose. Saying "From catalog" over an override is the lie
           that gets it "corrected" back by the next reader. -->
      @if (quantityProvenance(d) === 'authored') {
      <span
        class="pricing__authored-pill"
        [attr.data-testid]="'display-quantity-authored-' + d.__index"
      >
        <mat-icon aria-hidden="true">edit_note</mat-icon>
        Edited here
      </span>
      } @else {
      <span
        class="pricing__locked-pill"
        [attr.data-testid]="'display-quantity-locked-' + d.__index"
      >
        <mat-icon aria-hidden="true">lock</mat-icon>
        <!-- Only claim the catalog owns it when the backend actually says so;
             otherwise the pill states the fact it does know — it is locked. -->
        {{ quantityProvenance(d) === 'catalog' ? 'From catalog' : 'Locked' }}
      </span>
      }
      <enr-button
        variant="text"
        size="small"
        [attr.data-testid]="'display-quantity-unlock-' + d.__index"
        [leadingIcon]="true"
        (clicked)="startQuantityEdit(d)"
      >
        <span slot="leading-icon" class="flex items-center justify-center">
          <mat-icon
            class="size-4.5! text-[18px]! leading-4.5!"
            aria-hidden="true"
            >edit</mat-icon
          >
        </span>
        Edit
      </enr-button>
      <!-- Offered while LOCKED too: a saved override loads locked, and that is
           exactly when someone wants to hand it back. -->
      @if (quantityProvenance(d) === 'authored') {
      <enr-button
        variant="text"
        size="small"
        [attr.data-testid]="'display-quantity-use-catalog-' + d.__index"
        (clicked)="useCatalogQuantity(d)"
      >
        <mat-icon aria-hidden="true">undo</mat-icon>
        Use catalog
      </enr-button>
      } } @else {
      <enr-button
        variant="text"
        size="small"
        [attr.data-testid]="'display-quantity-cancel-' + d.__index"
        (clicked)="cancelQuantityEdit(d)"
      >
        Cancel
      </enr-button>
      <!-- Drops the authored figure so the save omits the key and the catalog
           resumes owning it. Hidden when there is nothing to hand back. -->
      @if (quantityProvenance(d) === 'authored') {
      <enr-button
        variant="text"
        size="small"
        [attr.data-testid]="'display-quantity-use-catalog-' + d.__index"
        (clicked)="useCatalogQuantity(d)"
      >
        <mat-icon aria-hidden="true">undo</mat-icon>
        Use catalog
      </enr-button>
      } }
    </div>

    <!-- Native, not `enr-input`, against the Omniark-first rule and on
         purpose: this cell shares a grid row with the billing and Validity
         amounts, which are native `.pricing__number` cells on the shared
         `--pr-field-*` tokens. One Omniark field among them breaks the row.
         See ADR 0001's second amendment. -->
    <input
      type="number"
      class="pricing__number"
      [value]="quantityValue(d)"
      [placeholder]="placeholder"
      [disabled]="!mayEditQuantityNow(d)"
      [attr.aria-readonly]="mayEditQuantityNow(d) ? null : 'true'"
      [attr.data-testid]="'display-quantity-' + d.__index"
      (input)="onQuantityInput(d, $event)"
    />

    <!-- The catalog's own figure, shown to EVERY reader: someone without the
         right still needs to know whether what they are looking at is the
         catalog's number or one a person chose. -->
    @if (catalogAmount(d) !== null) {
    <p
      class="pricing__quantity-catalog"
      [attr.data-testid]="'display-quantity-catalog-hint-' + d.__index"
    >
      Catalog: {{ catalogAmount(d) }}
    </p>
    } @if (!mayEditServiceQuantity()) {
    <p
      class="pricing__quantity-note"
      [attr.data-testid]="'display-quantity-no-perm-' + d.__index"
    >
      Needs the Enrichment Publish permission.
    </p>
    }
  </div>
</ng-template>

<ng-template #packageDrawerTemplate>
  <app-pricing-package-drawer (packageSelected)="onPackageSelected($event)" />
</ng-template>

<!-- Kind is otherwise only visible inside the collapsed card body. A
     displayOther without a kind gets a "Set kind" cue; a catalog display
     without one shows nothing. -->
<ng-template #svcKindPill let-d>
  @if (serviceKind(d); as b) {
  <span
    class="pricing__svc-kind"
    [attr.data-testid]="'pricing-svc-kind-badge-' + d.name"
    [style.background]="b.bg"
    [style.color]="b.fg"
    [title]="'Kind: ' + b.label"
  >
    <span class="pricing__svc-kind-tile" aria-hidden="true">
      @if (brokenKindIcons().has(b.icon)) {
      <span class="pricing__svc-kind-abbr">{{ b.abbr }}</span>
      } @else {
      <img
        class="pricing__svc-kind-icon"
        [src]="b.icon"
        alt=""
        (error)="markKindIconBroken(b.icon)"
      />
      }
    </span>
    {{ b.label }}
  </span>
  } @else if (isOtherDisplay(d)) {
  <span
    class="pricing__svc-kind pricing__svc-kind--missing"
    [attr.data-testid]="'pricing-svc-kind-missing-' + d.name"
  >
    Set kind
  </span>
  }
</ng-template>
